<template>
  <v-main>
    <v-container class="pa-0 ma-0" fluid style="height: 100vh">
      <v-layout justify-center style="height: 100%">
        <v-flex xs12>
          <v-card
            flat
            class="ma-0 pa-0"
            style="height: 100%; background-color: lightgray"
          >
            <v-toolbar
              v-touch="{
                left: () => swipe('Left'),
                right: () => swipe('Right'),
              }"
              id="mainToolbar"
              style="z-index: 2000"
              color="primary"
              dark
              flat
            >
              <v-icon color="white" class="mr-2">mdi-puzzle-edit</v-icon>
              <v-spacer></v-spacer>
              <v-toolbar-title v-if="$vuetify.breakpoint.mdAndUp"
                >{{ $t("userNewPhotoGiftOrderDesignTitle") }} ({{
                  $store.state.storePhotoGiftOrderDesign.itemCategory
                }}
                /
                {{ $store.state.storePhotoGiftOrderDesign.itemSubCategory }})
              </v-toolbar-title>
              <v-toolbar-title
                class="subtitle-1"
                style="line-height: 18px"
                v-else
              >
                {{ $t("userNewPhotoGiftOrderDesignTitle") }}<br />
                <span style="font-size: 12px"
                  >{{ $store.state.storePhotoGiftOrderDesign.itemCategory }}
                  /
                  {{
                    $store.state.storePhotoGiftOrderDesign.itemSubCategory
                  }}</span
                ></v-toolbar-title
              >
              <v-spacer></v-spacer>
              <!-- SHOW GO BACK BUTTON CONFIRM DIALOG -->
              <dialog-show-go-back
                :active="showGoBack"
                @clickYes="$router.push('/')"
                @clickNo="showGoBack = false"
              ></dialog-show-go-back>

              <template v-slot:extension>
                <v-tabs
                  v-model="tab"
                  show-arrows
                  align-with-title
                  center-active
                  next-icon="mdi-arrow-right-bold-box-outline"
                  prev-icon="mdi-arrow-left-bold-box-outline"
                  fixed-tabs
                >
                  <v-tab
                    v-for="(item, index) in $store.state
                      .storePhotoGiftOrderDesign.canvasTemplates"
                    :key="index"
                    @change="clickTabChange(index)"
                  >
                    <v-badge
                      v-if="
                        $store.state.storePhotoGiftOrderDesign.canvasTemplates[
                          index
                        ].cUrl &&
                        $store.state.storePhotoGiftOrderDesign.canvasTemplates[
                          index
                        ].cUrl.length > 0
                      "
                      color="success"
                      dot
                    >
                      {{ item.title }}
                    </v-badge>
                    <div v-else>{{ item.title }}</div>
                  </v-tab>
                </v-tabs>
              </template>
            </v-toolbar>

            <!-- MAIN TOOLBAR -->
            <v-toolbar
              v-touch="{
                left: () => swipe('Left'),
                right: () => swipe('Right'),
              }"
              id="mainCardToolbar"
              class="d-flex flex-wrap justify-center pa-0 ma-0"
              style="background-color: white; z-index: 2000"
              flat
              min-height="94"
            >
              <!-- SHOW ZOOM CONTROLS -->
              <div
                v-if="
                  $store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
                    .canvas.showZoomControls
                "
                class="d-flex flex-wrap justify-center pa-0 ma-0"
              >
                <!-- CARD BACK TO EDIT -->
                <v-card
                  flat
                  outlined
                  style="border: 1px solid lightgrey; min-width: 48px"
                  class="pa-0 ma-0 mt-8 mr-1"
                >
                  <v-card-title
                    class="
                      ma-0
                      pa-0
                      px-1
                      caption
                      font-weight-normal
                      justify-center
                      grey
                      lighten-4
                      grey--text
                    "
                    ><div class="headerClass">
                      {{ $t("fabricZoomBackTitle") }}
                    </div></v-card-title
                  >
                  <v-card-actions class="ma-0 pa-0 px-1">
                    <v-spacer></v-spacer>

                    <!-- GUMB EDIT -->
                    <v-card
                      flat
                      class="ma-0 pa-0 hover-item"
                      :style="
                        $vuetify.breakpoint.width > 360
                          ? 'width: 48px; max-width: 48px'
                          : 'width: 38px; max-width: 38px'
                      "
                      @click="
                        $store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.showZoomControls = false;
                        cZoom = panzoom.getScale();
                        cPan = panzoom.getPan();
                        panzoom.destroy();
                      "
                    >
                      <v-card-actions class="justify-center ma-0 pa-0">
                        <v-icon color="accent" class="mt-1">mdi-pencil</v-icon>
                      </v-card-actions>
                      <v-card-title
                        style="font-size: 10px"
                        class="
                          ma-0
                          pa-0
                          px-1
                          font-weight-normal
                          justify-center
                          grey--text
                        "
                        ><div class="headerClass">
                          {{ $t("fabricZoomEditBackTitle") }}
                        </div></v-card-title
                      >
                    </v-card>

                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>

                <!-- CARD MAIN ZOOM CONTROLS -->
                <v-card
                  flat
                  outlined
                  style="border: 1px solid lightgrey; min-width: 48px"
                  class="pa-0 ma-0 mt-8 mr-1"
                >
                  <v-card-title
                    class="
                      ma-0
                      pa-0
                      px-1
                      caption
                      font-weight-normal
                      justify-center
                      grey
                      lighten-4
                      grey--text
                    "
                    ><div class="headerClass">
                      {{ $t("fabricZoomMainControlsTitle") }}
                    </div></v-card-title
                  >
                  <v-card-actions class="ma-0 pa-0 px-1">
                    <v-spacer></v-spacer>

                    <!-- GUMB ZOOM IN -->
                    <v-card
                      flat
                      class="ma-0 pa-0 hover-item"
                      :style="
                        $vuetify.breakpoint.width > 360
                          ? 'width: 48px; max-width: 48px'
                          : 'width: 38px; max-width: 38px'
                      "
                      @click="panzoom.zoomIn()"
                    >
                      <v-card-actions class="justify-center ma-0 pa-0">
                        <v-icon color="accent" class="mt-1"
                          >mdi-magnify-plus</v-icon
                        >
                      </v-card-actions>
                      <v-card-title
                        style="font-size: 10px"
                        class="
                          ma-0
                          pa-0
                          px-1
                          font-weight-normal
                          justify-center
                          grey--text
                        "
                        ><div class="headerClass">
                          {{ $t("fabricZoomMainControlsInTitle") }}
                        </div></v-card-title
                      >
                    </v-card>

                    <!-- GUMB ZOOM OUT -->
                    <v-card
                      flat
                      class="ma-0 pa-0 hover-item"
                      :style="
                        $vuetify.breakpoint.width > 360
                          ? 'width: 48px; max-width: 48px'
                          : 'width: 38px; max-width: 38px'
                      "
                      @click="panzoom.zoomOut()"
                    >
                      <v-card-actions class="justify-center ma-0 pa-0">
                        <v-icon color="accent" class="mt-1"
                          >mdi-magnify-minus</v-icon
                        >
                      </v-card-actions>
                      <v-card-title
                        style="font-size: 10px"
                        class="
                          ma-0
                          pa-0
                          px-1
                          font-weight-normal
                          justify-center
                          grey--text
                        "
                        ><div class="headerClass">
                          {{ $t("fabricZoomMainControlsOutTitle") }}
                        </div></v-card-title
                      >
                    </v-card>

                    <!-- GUMB ZOOM RESET -->
                    <v-card
                      flat
                      class="ma-0 pa-0 hover-item"
                      :style="
                        $vuetify.breakpoint.width > 360
                          ? 'width: 48px; max-width: 48px'
                          : 'width: 38px; max-width: 38px'
                      "
                      @click="
                        cZoom = 1;
                        panzoom.reset();
                      "
                    >
                      <v-card-actions class="justify-center ma-0 pa-0">
                        <v-icon color="accent" class="mt-1"
                          >mdi-magnify-scan</v-icon
                        >
                      </v-card-actions>
                      <v-card-title
                        style="font-size: 10px"
                        class="
                          ma-0
                          pa-0
                          px-1
                          font-weight-normal
                          justify-center
                          grey--text
                        "
                        ><div class="headerClass">
                          {{ $t("fabricZoomMainControlsDefaultTitle") }}
                        </div></v-card-title
                      >
                    </v-card>

                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </div>

              <!-- SHOW FREE DRAWING CONTROLS -->
              <div
                v-else-if="
                  $store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
                    .canvas.showFreeDrawingControls
                "
                class="d-flex flex-wrap justify-center pa-0 ma-0"
              >
                <!-- CARD FREE DRAWING APPLY CANCEL -->
                <v-card
                  flat
                  outlined
                  style="border: 1px solid lightgrey; min-width: 48px"
                  class="pa-0 ma-0 mt-8 mr-1"
                >
                  <v-card-title
                    class="
                      ma-0
                      pa-0
                      px-1
                      caption
                      font-weight-normal
                      justify-center
                      grey
                      lighten-4
                      grey--text
                    "
                    >{{ $t("fabricFreeHandChanges") }}</v-card-title
                  >
                  <v-card-actions class="ma-0 pa-0 px-1">
                    <v-spacer></v-spacer>

                    <!-- GUMB UVELJAVI SPREMEMBE -->
                    <v-card
                      flat
                      class="ma-0 pa-0 hover-item"
                      style="min-width: 48px"
                      @click="applyFreeDrawing"
                    >
                      <v-card-actions class="justify-center ma-0 pa-0">
                        <v-icon color="accent" class="mt-1"
                          >mdi-star-check</v-icon
                        >
                      </v-card-actions>
                      <v-card-title
                        style="font-size: 10px"
                        class="
                          ma-0
                          pa-0
                          px-1
                          font-weight-normal
                          justify-center
                          grey--text
                        "
                        >{{ $t("fabricFreeDrawingApply") }}</v-card-title
                      >
                    </v-card>
                    <v-spacer></v-spacer>
                    <!-- GUMB PREKLIČI SPREMEMBE -->
                    <v-card
                      flat
                      class="ma-0 pa-0 hover-item"
                      style="min-width: 48px"
                      @click="cancelFreeDrawing"
                    >
                      <v-card-actions class="justify-center ma-0 pa-0">
                        <v-icon color="accent" class="mt-1"
                          >mdi-close-thick</v-icon
                        >
                      </v-card-actions>
                      <v-card-title
                        style="font-size: 10px"
                        class="
                          ma-0
                          pa-0
                          px-1
                          font-weight-normal
                          justify-center
                          grey--text
                        "
                        >{{ $t("fabricFreeDrawingCancel") }}</v-card-title
                      >
                    </v-card>

                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>

                <!-- CARD FREE DRAWING BRUSH -->
                <v-card
                  flat
                  outlined
                  style="border: 1px solid lightgrey; min-width: 48px"
                  class="pa-0 ma-0 mt-8 mr-1"
                >
                  <v-card-title
                    class="
                      ma-0
                      pa-0
                      px-1
                      caption
                      font-weight-normal
                      justify-center
                      grey
                      lighten-4
                      grey--text
                    "
                    >{{ $t("fabricFreeDrawingBrush") }}</v-card-title
                  >
                  <v-card-actions class="ma-0 pa-0 px-1">
                    <v-spacer></v-spacer>

                    <!-- GUMB BARVA ČOPIČA -->
                    <v-menu :close-on-content-click="true">
                      <template v-slot:activator="{ on }">
                        <v-card flat class="ma-0 pa-0 hover-item" v-on="on">
                          <v-card-actions class="justify-center ma-0 pa-0">
                            <v-icon
                              :color="freeDrawingSettings.strokeColor"
                              style="border: 1px solid silver"
                              >mdi-square</v-icon
                            >
                          </v-card-actions>
                          <v-card-title
                            style="font-size: 10px"
                            class="
                              ma-0
                              pa-0
                              px-1
                              font-weight-normal
                              justify-center
                              grey--text
                            "
                            >{{ $t("fabricTextOutlineColor") }}</v-card-title
                          >
                        </v-card>
                      </template>
                      <v-card>
                        <v-card-text class="pa-0">
                          <v-color-picker
                            flat
                            :hide-mode-switch="true"
                            show-swatches
                            hide-canvas
                            hide-inputs
                            :dot-size="20"
                            v-model="freeDrawingSettings.strokeColor"
                            :swatches-max-height="
                              $vuetify.breakpoint.height / 1.5
                            "
                            @input="
                              $store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.freeDrawingBrush.color =
                                freeDrawingSettings.strokeColor
                            "
                          />
                        </v-card-text>
                      </v-card>
                    </v-menu>

                    <v-spacer></v-spacer>
                    <!-- GUMB DEBELINA ČOPIČA -->
                    <v-menu :close-on-content-click="true">
                      <template v-slot:activator="{ on }">
                        <v-card flat class="ma-0 pa-0 hover-item" v-on="on">
                          <v-card-actions class="justify-center ma-0 pa-0">
                            <span style="text-color: 505050"
                              >{{ freeDrawingSettings.strokeWidth }}
                            </span>
                          </v-card-actions>
                          <v-card-title
                            style="font-size: 10px"
                            class="
                              ma-0
                              pa-0
                              px-1
                              font-weight-normal
                              justify-center
                              grey--text
                            "
                            >{{ $t("fabricTextOutlineWidth") }}</v-card-title
                          >
                        </v-card>
                      </template>
                      <v-card class="pa-4">
                        <v-card-text class="pa-0">
                          <v-slider
                            v-model="freeDrawingSettings.strokeWidth"
                            class="align-center"
                            :max="300"
                            :min="1"
                            hide-details
                            vertical
                            @change="
                              $store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.freeDrawingBrush.width =
                                freeDrawingSettings.strokeWidth
                            "
                          ></v-slider>
                        </v-card-text>
                      </v-card>
                    </v-menu>

                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>

                <!-- CARD FREE DRAWING SHADOW -->
                <v-card
                  flat
                  outlined
                  style="border: 1px solid lightgrey; min-width: 48px"
                  class="pa-0 ma-0 mt-8 mr-1"
                >
                  <v-card-title
                    class="
                      ma-0
                      pa-0
                      px-1
                      caption
                      font-weight-normal
                      justify-center
                      grey
                      lighten-4
                      grey--text
                    "
                    >{{ $t("fabricFreeDrawingShadow") }}</v-card-title
                  >
                  <v-card-actions class="ma-0 pa-0 px-1">
                    <v-spacer></v-spacer>

                    <!-- GUMB BARVA SENCE -->
                    <v-menu :close-on-content-click="true">
                      <template v-slot:activator="{ on }">
                        <v-card flat class="ma-0 pa-0 hover-item" v-on="on">
                          <v-card-actions class="justify-center ma-0 pa-0">
                            <v-icon
                              :color="freeDrawingSettings.shadowColor"
                              style="border: 1px solid silver"
                              >mdi-square</v-icon
                            >
                          </v-card-actions>
                          <v-card-title
                            style="font-size: 10px"
                            class="
                              ma-0
                              pa-0
                              px-1
                              font-weight-normal
                              justify-center
                              grey--text
                            "
                            >{{ $t("fabricTextOutlineColor") }}</v-card-title
                          >
                        </v-card>
                      </template>
                      <v-card>
                        <v-card-text class="pa-0">
                          <v-color-picker
                            flat
                            :hide-mode-switch="true"
                            show-swatches
                            hide-canvas
                            hide-inputs
                            :dot-size="20"
                            v-model="freeDrawingSettings.shadowColor"
                            :swatches-max-height="
                              $vuetify.breakpoint.height / 1.5
                            "
                            @input="
                              $store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.freeDrawingBrush.shadow.color =
                                freeDrawingSettings.shadowColor
                            "
                          />
                        </v-card-text>
                      </v-card>
                    </v-menu>

                    <v-spacer></v-spacer>
                    <!-- GUMB DEBELINA SENCE -->
                    <v-menu :close-on-content-click="true">
                      <template v-slot:activator="{ on }">
                        <v-card flat class="ma-0 pa-0 hover-item" v-on="on">
                          <v-card-actions class="justify-center ma-0 pa-0">
                            <span style="text-color: 505050"
                              >{{ freeDrawingSettings.shadowBlur }}
                            </span>
                          </v-card-actions>
                          <v-card-title
                            style="font-size: 10px"
                            class="
                              ma-0
                              pa-0
                              px-1
                              font-weight-normal
                              justify-center
                              grey--text
                            "
                            >{{ $t("fabricTextOutlineWidth") }}</v-card-title
                          >
                        </v-card>
                      </template>
                      <v-card class="pa-4">
                        <v-card-text class="pa-0">
                          <v-slider
                            v-model="freeDrawingSettings.shadowBlur"
                            class="align-center"
                            :max="300"
                            :min="1"
                            hide-details
                            vertical
                            @change="
                              $store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.freeDrawingBrush.shadow.blur =
                                freeDrawingSettings.shadowBlur
                            "
                          ></v-slider>
                        </v-card-text>
                      </v-card>
                    </v-menu>

                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </div>

              <!-- SHOW TEXT EDITING  CONTROLS -->
              <div
                v-else-if="
                  $store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
                    .canvas.showTextControls
                "
                class="d-flex flex-wrap justify-center pa-0 ma-0"
              >
                <fabric-text-controls-card
                  class="mt-8"
                  :template="
                    $store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
                  "
                ></fabric-text-controls-card>
              </div>

              <!-- SHOW BACKGROUND IMAGE CONTROLS -->
              <div
                v-else-if="
                  $store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
                    .canvas.showBackgroundImageControls &&
                  $store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
                    .canvas.showFillBackControls
                "
                class="d-flex flex-wrap justify-center pa-0 ma-0"
              >
                <fabric-background-image-controls-card
                  class="mt-8"
                  :template="
                    $store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
                  "
                  backBtn
                ></fabric-background-image-controls-card>
              </div>

              <!-- SHOW SIMPLE AND FRAME PLACEHOLDER  IMAGE CONTROLS -->
              <div
                v-else-if="
                  $store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
                    .canvas.showSimplePlaceholderImageControls
                "
                class="d-flex flex-no-wrap justify-center pa-0 ma-0"
              >
                <fabric-simple-placeholder-image-controls-card
                  class="mt-8"
                  :template="
                    $store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
                  "
                  :iIndex="$store.state.storePhotoGiftOrderDesign.iIndex"
                  :imageSettings="filterImageSettings"
                  :index="filterImageIndex"
                ></fabric-simple-placeholder-image-controls-card>

                <fabric-simple-frame-controls-card
                  class="mt-8"
                  v-if="
                    $store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
                      .canvas.showSimpleFrameRect
                  "
                  :template="
                    $store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
                  "
                  :simpleFrameRect="
                    $store.state.storePhotoGiftOrderDesign.cIndexMode ==
                    'addNewSimpleSquareImage'
                  "
                  frame
                ></fabric-simple-frame-controls-card>
              </div>

              <!-- SHOW MAIN CONTROLS -->
              <div v-else class="d-flex justify-center pa-0 ma-0">
                <!-- CARD BACKGROUND -->
                <v-card
                  flat
                  outlined
                  style="border: 1px solid lightgrey; min-width: 48px"
                  v-if="
                    $store.state.storePhotoGiftOrderDesign.canvasTemplates[
                      activeTab
                    ].allowBackground
                  "
                  class="pa-0 ma-0 mt-8 mr-1"
                >
                  <v-card-title
                    class="
                      ma-0
                      pa-0
                      px-1
                      caption
                      font-weight-normal
                      justify-center
                      grey
                      lighten-4
                      grey--text
                    "
                    ><div
                      class="headerClass"
                      v-if="
                        !$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                          activeTab
                        ].mainImageBackground
                      "
                    >
                      {{ $t("fabricBackgroundGroupControlsTitle") }}
                    </div>
                    <div class="headerClass" v-else>
                      {{ $t("fabricBackgroundGroupControlsBackgroundTitle") }}
                    </div>
                  </v-card-title>
                  <v-card-actions class="ma-0 pa-0 px-1">
                    <v-spacer></v-spacer>

                    <!-- CARD SET BACKGROUND IMAGE WITH MENU -->
                    <div
                      v-if="
                        $store.state.storePhotoGiftOrderDesign.canvasTemplates[
                          activeTab
                        ].allowBackground
                      "
                    >
                      <v-menu
                        :close-on-content-click="true"
                        offset-y
                        transition="slide-x-transition"
                      >
                        <template v-slot:activator="{ on }">
                          <v-card
                            flat
                            class="ma-0 pa-0 hover-item"
                            v-on="on"
                            :style="
                              $vuetify.breakpoint.width > 360
                                ? 'width: 48px; max-width: 48px'
                                : 'width: 38px; max-width: 38px'
                            "
                          >
                            <v-card-actions class="justify-center ma-0 pa-0">
                              <v-icon color="accent" class="mt-1"
                                >mdi-file-image</v-icon
                              >
                            </v-card-actions>
                            <v-card-title
                              style="font-size: 10px"
                              class="
                                ma-0
                                pa-0
                                px-1
                                font-weight-normal
                                justify-center
                                grey--text
                              "
                              ><div class="headerClass">
                                {{ $t("fabricPreviewBackground") }}
                              </div></v-card-title
                            >
                          </v-card>
                        </template>
                        <v-list>
                          <!-- SELECT USER BACKGROUND -->
                          <v-list-item
                            dense
                            class="hover-item"
                            @click="handlerAddNewImage('addNewImageBackground')"
                          >
                            <v-list-item-icon>
                              <v-icon>mdi-upload</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>{{
                                $t("fabricBackgroundImageAddImageTitle")
                              }}</v-list-item-title></v-list-item-content
                            >
                            <input
                              id="addNewImageBackgroundFileInput"
                              v-if="uploadReady"
                              class="d-none"
                              type="file"
                              accept="image/jpeg, image/png, image/gif, image/jpg, image/heic, image/heif"
                              @change="addNewImage"
                            />
                          </v-list-item>
                          <!-- SELECT PIXABAY BACKGROUND -->
                          <v-list-item
                            dense
                            class="hover-item"
                            @click="servePixabayBackgroundImageSelection"
                            v-if="
                              !isMaxCanvasLimit ||
                              (isMaxCanvasLimit &&
                                !$store.state.storePhotoGiftOrderDesign
                                  .enableDeviceBasedEdit)
                            "
                          >
                            <v-list-item-icon>
                              <v-img
                                style="width: 24px"
                                :src="require('@/assets/pixabay.svg')"
                              ></v-img>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>{{
                                $t(
                                  "fabricBackgroundImageAddPixabayBackgroundTitle"
                                )
                              }}</v-list-item-title></v-list-item-content
                            >
                          </v-list-item>
                          <!-- SELECT PIXABAY PATTERN -->
                          <v-list-item
                            dense
                            class="hover-item"
                            @click="servePixabayBackgroundPatternSelection"
                            v-if="
                              !isMaxCanvasLimit ||
                              (isMaxCanvasLimit &&
                                !$store.state.storePhotoGiftOrderDesign
                                  .enableDeviceBasedEdit)
                            "
                          >
                            <v-list-item-icon>
                              <v-img
                                style="width: 24px"
                                :src="require('@/assets/pixabay.svg')"
                              ></v-img>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>{{
                                $t(
                                  "fabricBackgroundImageAddPixabayPatternTitle"
                                )
                              }}</v-list-item-title></v-list-item-content
                            >
                          </v-list-item>
                          <!-- SELECT BACKGROUND -->
                          <!--<v-list-item
                                                    dense
                                                    class="hover-item"
                                                    @click="
                                                      serveBackgroundImageSelection(
                                                        activeTab
                                                      )
                                                    "
                                                  >
                                                    <v-list-item-icon>
                                                      <v-icon
                                                        >mdi-image-multiple</v-icon
                                                      >
                                                    </v-list-item-icon>
                                                    <v-list-item-content>
                                                      <v-list-item-title>{{
                                                        $t(
                                                          "fabricBackgroundImageAddBackgroundTitle"
                                                        )
                                                      }}</v-list-item-title></v-list-item-content
                                                    >
                                                  </v-list-item>-->
                          <!-- SELECT PATTERN BACKGROUND -->
                          <!--<v-list-item
                                                    dense
                                                    class="hover-item"
                                                    @click="
                                                      servePatternImageSelection(
                                                        activeTab
                                                      )
                                                    "
                                                  >
                                                    <v-list-item-icon>
                                                      <v-icon
                                                        >mdi-view-grid-plus</v-icon
                                                      >
                                                    </v-list-item-icon>
                                                    <v-list-item-content>
                                                      <v-list-item-title>{{
                                                        $t(
                                                          "fabricBackgroundImageAddPatternTitle"
                                                        )
                                                      }}</v-list-item-title></v-list-item-content
                                                    >
                                                  </v-list-item>-->
                          <!-- SELECT COLOR BACKGROUND -->
                          <v-list-item
                            dense
                            class="hover-item"
                            @click="handlerAddColorPicker"
                            v-if="
                              !isMaxCanvasLimit ||
                              (isMaxCanvasLimit &&
                                !$store.state.storePhotoGiftOrderDesign
                                  .enableDeviceBasedEdit)
                            "
                          >
                            <v-list-item-icon>
                              <v-icon>mdi-format-color-fill</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>{{
                                $t("fabricBackgroundImageAddColorTitle")
                              }}</v-list-item-title></v-list-item-content
                            >
                          </v-list-item>
                          <!-- RESET BACKGROUND -->
                          <v-list-item
                            v-if="
                              $store.state.storePhotoGiftOrderDesign
                                .canvasTemplates[activeTab].selected
                                .rulesBackground.type != 'none'
                            "
                            dense
                            class="hover-item"
                            @click="setBackgroundLayerSetter"
                          >
                            <v-list-item-icon>
                              <v-icon>mdi-card</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>{{
                                $t("fabricBackgroundImageStartBackgroundTitle")
                              }}</v-list-item-title></v-list-item-content
                            >
                          </v-list-item>
                          <!-- REMOVE BACKGROUND -->
                          <v-list-item
                            dense
                            class="hover-item"
                            @click="handlerRemoveBackground(activeTab)"
                          >
                            <v-list-item-icon>
                              <v-icon>mdi-card-off-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>{{
                                $t("fabricBackgroundImageResetBackgroundTitle")
                              }}</v-list-item-title></v-list-item-content
                            >
                          </v-list-item>
                          <!-- BACKGROUND FILTERS -->
                          <v-list-item
                            v-if="
                              $store.state.storePhotoGiftOrderDesign
                                .canvasTemplates[0].canvas
                                .showBackgroundImageControls
                            "
                            dense
                            class="hover-item"
                            style="border-top: 1px solid lightgrey"
                            @click="
                              $store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.showFillBackControls = true
                            "
                          >
                            <v-list-item-icon>
                              <v-icon>mdi-image-filter-vintage</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>{{
                                $t("fabricBackgroundImageShowFilters")
                              }}</v-list-item-title></v-list-item-content
                            >
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>

                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>

                <!-- SHOW PRICE ON/OFF FOR GIFT CARDS ONLY -->
                <v-card
                  flat
                  outlined
                  style="border: 1px solid lightgrey; min-width: 48px"
                  v-if="showPrice"
                  class="pa-0 ma-0 mt-8 mr-1"
                  @click="giftCardPriceOnOff"
                >
                  <v-card-title
                    class="
                      ma-0
                      pa-0
                      px-1
                      caption
                      font-weight-normal
                      justify-center
                      grey
                      lighten-4
                      grey--text
                    "
                    ><div class="headerClass">
                      {{
                        $t("fabricTextFunctionGiftCardUserPrice").toLowerCase()
                      }}
                    </div></v-card-title
                  ><v-card-actions class="justify-center ma-0 pa-0">
                    <v-icon
                      v-if="giftCardPriceToggle"
                      color="accent"
                      class="mt-1"
                      >mdi-currency-usd-off</v-icon
                    >
                    <v-icon v-else color="accent" class="mt-1"
                      >mdi-currency-usd</v-icon
                    >
                  </v-card-actions>
                  <v-card-title
                    style="font-size: 10px"
                    class="
                      ma-0
                      pa-0
                      px-1
                      font-weight-normal
                      justify-center
                      grey--text
                    "
                    ><div class="headerClass" v-if="giftCardPriceToggle">
                      {{ $t("fabricTextFunctionGiftCardUserPriceOff") }}
                    </div>
                    <div class="headerClass" v-else>
                      {{ $t("fabricTextFunctionGiftCardUserPriceOn") }}
                    </div></v-card-title
                  >
                </v-card>

                <!-- CARD ADD NEW ELEMENTS -->
                <v-card
                  flat
                  outlined
                  style="border: 1px solid lightgrey; min-width: 48px"
                  v-if="
                    ($store.state.storePhotoGiftOrderDesign.canvasTemplates[
                      activeTab
                    ].allowImages ||
                      $store.state.storePhotoGiftOrderDesign.canvasTemplates[
                        activeTab
                      ].allowText ||
                      $store.state.storePhotoGiftOrderDesign.canvasTemplates[
                        activeTab
                      ].allowStickers ||
                      $store.state.storePhotoGiftOrderDesign.canvasTemplates[
                        activeTab
                      ].allowFreeDrawing) &&
                    (!isMaxCanvasLimit ||
                      (isMaxCanvasLimit &&
                        !$store.state.storePhotoGiftOrderDesign
                          .enableDeviceBasedEdit))
                  "
                  class="pa-0 ma-0 mt-8 mr-1"
                >
                  <v-card-title
                    class="
                      ma-0
                      pa-0
                      px-1
                      caption
                      font-weight-normal
                      justify-center
                      grey
                      lighten-4
                      grey--text
                    "
                    ><div class="headerClass">
                      {{ $t("fabricElementsGroupControlsTitle") }}
                    </div></v-card-title
                  >
                  <v-card-actions class="ma-0 pa-0 px-1">
                    <v-spacer></v-spacer>

                    <!-- MENU SELECT NEW PHOTO ADD -->
                    <div
                      v-if="
                        $store.state.storePhotoGiftOrderDesign.canvasTemplates[
                          activeTab
                        ].allowImages
                      "
                    >
                      <v-menu
                        :close-on-content-click="true"
                        offset-y
                        transition="slide-x-transition"
                      >
                        <template v-slot:activator="{ on }">
                          <v-card
                            flat
                            class="ma-0 pa-0 hover-item"
                            v-on="on"
                            :style="
                              $vuetify.breakpoint.width > 360
                                ? 'width: 48px; max-width: 48px'
                                : 'width: 38px; max-width: 38px'
                            "
                          >
                            <v-card-actions class="justify-center ma-0 pa-0">
                              <v-icon color="accent" class="mt-1"
                                >mdi-image-outline</v-icon
                              >
                            </v-card-actions>
                            <v-card-title
                              style="font-size: 10px"
                              class="
                                ma-0
                                pa-0
                                px-1
                                font-weight-normal
                                justify-center
                                grey--text
                              "
                              ><div class="headerClass">
                                {{ $t("fabricAddImage") }}
                              </div></v-card-title
                            >
                          </v-card>
                        </template>
                        <v-list>
                          <!-- ADD NEW SIMPLE SQARE  IMAGE -->
                          <v-list-item
                            dense
                            class="hover-item"
                            @click="serveFrameSimpleSquareImageSelection"
                          >
                            <v-list-item-icon>
                              <v-icon>mdi-square-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>{{
                                $t("fabricAddSimpleFrame")
                              }}</v-list-item-title></v-list-item-content
                            >
                            <input
                              id="addNewSimpleSquareImageFileInput"
                              v-if="uploadReady"
                              class="d-none"
                              type="file"
                              accept="image/jpeg, image/png, image/gif, image/jpg, image/heic, image/heif"
                              @change="addNewImage"
                            />
                          </v-list-item>

                          <!-- ADD NEW SIMPLE CIRCE  IMAGE -->
                          <v-list-item
                            dense
                            class="hover-item"
                            @click="serveFrameSimpleCircleImageSelection"
                          >
                            <v-list-item-icon>
                              <v-icon>mdi-circle-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>{{
                                $t("fabricAddSimpleFrame2")
                              }}</v-list-item-title></v-list-item-content
                            >
                            <input
                              id="addNewSimpleCircleImageFileInput"
                              class="d-none"
                              type="file"
                              accept="image/jpeg, image/png, image/gif, image/jpg, image/heic, image/heif"
                              @change="addNewImage"
                            />
                          </v-list-item>

                          <!-- ADD NEW FRAME IMAGE -->
                          <v-list-item
                            dense
                            class="hover-item"
                            @click="serveFrameImageSelection"
                          >
                            <v-list-item-icon>
                              <v-icon>mdi-image-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>{{
                                $t("fabricAddFrame")
                              }}</v-list-item-title></v-list-item-content
                            >
                            <input
                              id="addNewImageFileInput"
                              class="d-none"
                              type="file"
                              accept="image/jpeg, image/png, image/gif, image/jpg, image/heic, image/heif"
                              @change="addNewImage"
                            />
                          </v-list-item>

                          <!-- GUMB ADD NEW COLLAGE -->
                          <v-list-item
                            dense
                            class="hover-item"
                            @click="handlerAddCollage('addNewCollage')"
                          >
                            <v-list-item-icon>
                              <v-icon>mdi-collage</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title>{{
                                $t("fabricAddCollage")
                              }}</v-list-item-title></v-list-item-content
                            >
                            <input
                              id="addCollageFileInput"
                              v-if="uploadReady"
                              class="d-none"
                              type="file"
                              accept="image/jpeg, image/png, image/gif, image/jpg, image/heic, image/heif"
                              multiple
                              @change="generateCollage"
                            />
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>

                    <!-- GUMB ADD NEW STICKER -->
                    <div
                      v-if="
                        $store.state.storePhotoGiftOrderDesign.canvasTemplates[
                          activeTab
                        ].allowStickers
                      "
                    >
                      <v-card
                        flat
                        class="ma-0 pa-0 hover-item"
                        :style="
                          $vuetify.breakpoint.width > 360
                            ? 'width: 48px; max-width: 48px'
                            : 'width: 38px; max-width: 38px'
                        "
                        @click="serveStickersSelection"
                      >
                        <v-card-actions class="justify-center ma-0 pa-0">
                          <v-icon color="accent" class="mt-1"
                            >mdi-sticker-emoji</v-icon
                          >
                        </v-card-actions>
                        <v-card-title
                          style="font-size: 10px"
                          class="
                            ma-0
                            pa-0
                            px-1
                            font-weight-normal
                            justify-center
                            grey--text
                          "
                          ><div class="headerClass">
                            {{ $t("fabricAddSticker") }}
                          </div></v-card-title
                        >
                      </v-card>
                    </div>

                    <!-- GUMB ADD NEW TEXT -->
                    <div
                      v-if="
                        $store.state.storePhotoGiftOrderDesign.canvasTemplates[
                          activeTab
                        ].allowText
                      "
                    >
                      <v-card
                        flat
                        class="ma-0 pa-0 hover-item"
                        :style="
                          $vuetify.breakpoint.width > 360
                            ? 'width: 48px; max-width: 48px'
                            : 'width: 38px; max-width: 38px'
                        "
                        @click="serveNewText"
                      >
                        <v-card-actions class="justify-center ma-0 pa-0">
                          <v-icon color="accent" class="mt-1"
                            >mdi-format-text-variant-outline</v-icon
                          >
                        </v-card-actions>
                        <v-card-title
                          style="font-size: 10px"
                          class="
                            ma-0
                            pa-0
                            px-1
                            font-weight-normal
                            justify-center
                            grey--text
                          "
                          ><div class="headerClass">
                            {{ $t("fabricAddText") }}
                          </div></v-card-title
                        >
                      </v-card>
                    </div>

                    <!-- GUMB ADD NEW FREE DRAWING -->
                    <div
                      v-if="
                        $store.state.storePhotoGiftOrderDesign.canvasTemplates[
                          activeTab
                        ].allowFreeDrawing
                      "
                    >
                      <v-card
                        flat
                        class="ma-0 pa-0 hover-item"
                        :style="
                          $vuetify.breakpoint.width > 360
                            ? 'width: 48px; max-width: 48px'
                            : 'width: 38px; max-width: 38px'
                        "
                        @click="addFreeDrawing"
                      >
                        <v-card-actions class="justify-center ma-0 pa-0">
                          <v-icon color="accent" class="mt-1">mdi-draw</v-icon>
                        </v-card-actions>
                        <v-card-title
                          style="font-size: 10px"
                          class="
                            ma-0
                            pa-0
                            px-1
                            font-weight-normal
                            justify-center
                            grey--text
                          "
                          ><div class="headerClass">
                            {{ $t("fabricAddFree") }}
                          </div></v-card-title
                        >
                      </v-card>
                    </div>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>

                <!-- CARD ZOOM -->
                <v-card
                  flat
                  outlined
                  style="border: 1px solid lightgrey; min-width: 48px"
                  class="pa-0 ma-0 mt-8 mr-1"
                >
                  <v-card-title
                    class="
                      ma-0
                      pa-0
                      px-1
                      caption
                      font-weight-normal
                      justify-center
                      grey
                      lighten-4
                      grey--text
                    "
                    ><div class="headerClass">
                      {{ $t("fabricZoomGroupControlsTitle") }}
                    </div></v-card-title
                  >
                  <v-card-actions class="ma-0 pa-0 px-1">
                    <v-spacer></v-spacer>

                    <!-- GUMB ZOOM -->
                    <v-card
                      flat
                      class="ma-0 pa-0 hover-item"
                      :style="
                        $vuetify.breakpoint.width > 360
                          ? 'width: 48px; max-width: 48px'
                          : 'width: 38px; max-width: 38px'
                      "
                      @click="serveZoomCanvas"
                    >
                      <v-card-actions class="justify-center ma-0 pa-0">
                        <v-icon color="accent" class="mt-1">mdi-magnify</v-icon>
                      </v-card-actions>
                      <v-card-title
                        style="font-size: 10px"
                        class="
                          ma-0
                          pa-0
                          px-1
                          font-weight-normal
                          justify-center
                          grey--text
                        "
                        ><div class="headerClass">
                          {{ $t("fabricZoomGroupControlsSubTitle") }}
                        </div></v-card-title
                      >
                    </v-card>

                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </div>
            </v-toolbar>

            <!-- MAIN FORM WITH CANVAS -->
            <v-card-text
              class="pa-0 ma-0 d-flex align-center flex-wrap"
              style="
                height: 100%;
                overflow: hidden;
                background-color: lightgray;
                z-index: 1000;
              "
              id="mainCardText"
              ><v-spacer></v-spacer>
              <v-form enctype="multipart/form-data" novalidate>
                <div id="canvas-0" class="pa-0 ma-0 canvasShadow">
                  <v-btn
                    v-if="isMaxCanvasLimit"
                    style="margin-bottom: 90px; margin-left: 50px"
                    color="warning"
                    fab
                    text
                    dark
                    small
                    absolute
                    bottom
                    right
                    @click="dialogMaxCanvas = true"
                  >
                    <v-icon>mdi-alert</v-icon>
                  </v-btn>
                  <canvas
                    ref="fabricCanvas"
                    style="object-fit: contain; border: 1px solid gray"
                  ></canvas>
                </div>
              </v-form>
              <v-spacer></v-spacer>
            </v-card-text>

            <!-- FILE INPUTS -->
            <v-card-text
              v-touch="{
                left: () => swipe('Left'),
                right: () => swipe('Right'),
              }"
              id="mainCardFiles"
              class="d-flex pa-0 align-center justify-center"
              style="
                animation-delay: 3s;
                z-index: 2000;
                min-height: 48px;
                max-height: 48px;
                height: 48px;
              "
            >
              <div
                v-if="
                  'items' in
                    $store.state.storePhotoGiftOrderDesign.canvasTemplates[tab]
                      .selected &&
                  $store.state.storePhotoGiftOrderDesign.canvasTemplates[tab]
                    .selected.items.length > 0 &&
                  $store.state.storePhotoGiftOrderDesign.canvasTemplates[
                    activeTab
                  ].cUrl == ''
                "
                style="background-color: lightgray"
                class="d-flex pa-0 ma-0 overflow-x-auto"
              >
                <div
                  v-for="(item2, index2) in $store.state
                    .storePhotoGiftOrderDesign.canvasTemplates[tab].selected
                    .items"
                  :key="index2"
                  class="
                    d-flex
                    ma-0
                    pa-0
                    mx-1
                    px-1
                    align-center
                    justify-middle
                    title
                  "
                >
                  <v-btn
                    text
                    color="accent"
                    class="text-none"
                    depressed
                    @click="clickSimplePlaceholder(index2)"
                    style="width: 20px; max-width: 20px; min-width: 20px"
                  >
                    <v-icon>mdi-camera</v-icon>{{ index2 + 1 }}
                  </v-btn>
                  <input
                    :id="'canvas-0-input-' + index2"
                    class="d-none"
                    type="file"
                    accept="image/jpeg, image/png, image/gif, image/jpg, image/heic, image/heif"
                    @change="
                      filesChange(
                        $store.state.storePhotoGiftOrderDesign
                          .canvasTemplates[0],
                        item2,
                        index2
                      )
                    "
                    style="width: 24px; max-width: 24px"
                  />

                  <!-- ta nova komponenta ne omogoča custom ikone, zato uporabimo gumb z navadnim inputom zgoraj -->
                  <!--<v-file-input 
                    :id="'canvas-0-input-' + index2"
                    accept="image/jpeg, image/png, image/gif, image/jpg, image/heic, image/heif"
                    class="ma-0 pa-0"
                    style="width: 24px; max-width: 24px"
                    v-model="
                      $store.state.storePhotoGiftOrderDesign.canvasTemplates[
                        tab
                      ].files[index2]
                    "
                    :clearable="false"
                    hide-input
                    @change="
                      filesChange(
                        $store.state.storePhotoGiftOrderDesign
                          .canvasTemplates[0],
                        item2,
                        index2
                      )
                    "
                    ><v-icon slot="prepend" color="white"> mdi-camera </v-icon>
                  </v-file-input>-->
                </div>
              </div>
              <div
                v-if="
                  'rulesFrames' in
                    $store.state.storePhotoGiftOrderDesign.canvasTemplates[tab]
                      .selected ||
                  ($store.state.storePhotoGiftOrderDesign.canvasTemplates[tab]
                    .selected.rulesFrames.length > 0 &&
                    $store.state.storePhotoGiftOrderDesign.canvasTemplates[
                      activeTab
                    ].cUrl == '')
                "
                style="background-color: lightgray"
                class="d-flex pa-0 ma-0 align-center justify-center"
              >
                <div
                  v-for="(item3, index3) in $store.state
                    .storePhotoGiftOrderDesign.canvasTemplates[tab].selected
                    .rulesFrames"
                  :key="index3"
                  class="
                    d-flex
                    mx-1
                    pa-2
                    pl-4
                    align-center
                    justify-middle
                    title
                  "
                >
                  <v-file-input
                    :id="'canvas-0-input-frame-' + index3"
                    accept="image/jpeg, image/png, image/gif, image/jpg, image/heic, image/heif"
                    prepend-icon="mdi-camera"
                    v-model="
                      $store.state.storePhotoGiftOrderDesign.canvasTemplates[
                        tab
                      ].filesFrames[index3]
                    "
                    class="ma-0 pa-0"
                    style="width: 24px; max-width: 24px"
                    :clearable="false"
                    @change="
                      filesFramesChange(
                        $store.state.storePhotoGiftOrderDesign
                          .canvasTemplates[0],
                        item3,
                        index3
                      )
                    "
                    hide-input
                  ></v-file-input>
                </div>
              </div>

              <div
                v-if="
                  !itemsAvailable &&
                  $store.state.storePhotoGiftOrderDesign.canvasTemplates[
                    activeTab
                  ].cUrl != ''
                "
                style="min-height: 48px"
              >
                <!-- GUMB RESETIRAJ -->
                <v-btn
                  text
                  color="black"
                  outlined
                  class="ma-0 pa-0 px-2"
                  @click="dQReset = true"
                >
                  <v-icon color="black" class="mr-1">mdi-pencil</v-icon>
                  {{ $t("userNewPhotoGiftOrderDesignReEdit") }}
                </v-btn>
              </div>
            </v-card-text>

            <v-toolbar
              v-touch="{
                left: () => swipe('Left'),
                right: () => swipe('Right'),
              }"
              id="mainCardActions"
              color="primary"
              dark
              flat
              min-height="64"
              style="z-index: 2000"
            >
              <v-spacer></v-spacer>
              <!-- GUMB RESETIRAJ -->
              <v-card
                dark
                flat
                color="primary"
                class="ma-1 pa-1 hover-item white--text"
                :style="
                  $vuetify.breakpoint.width > 480
                    ? 'width: 68px; max-width: 68px'
                    : 'width: 38px; max-width: 38px'
                "
                @click="dQReset = true"
              >
                <v-card-text class="ma-0 pa-0 text-center">
                  <v-icon color="white">mdi-reload</v-icon>
                </v-card-text>
                <v-card-text
                  style="font-size: 10px"
                  class="ma-0 pa-0 font-weight-normal text-center white--text"
                  ><div class="headerClass">
                    {{ $t("lmBtnReset") }}
                  </div></v-card-text
                >
              </v-card>
              <!-- GUMB ZAMENJAJ -->
              <v-card
                v-if="
                  $store.state.storeImageTemplate.imageFilteredTemplate.length >
                  1
                "
                dark
                flat
                color="primary"
                class="ma-1 pa-1 hover-item white--text"
                :style="
                  $vuetify.breakpoint.width > 480
                    ? 'width: 68px; max-width: 68px'
                    : 'width: 38px; max-width: 38px'
                "
                @click="serveTemplateSelection(1)"
              >
                <v-card-text class="ma-0 pa-0 text-center">
                  <v-icon color="white">mdi-file-replace-outline</v-icon>
                </v-card-text>
                <v-card-text
                  style="font-size: 10px"
                  class="ma-0 pa-0 font-weight-normal text-center white--text"
                  ><div class="headerClass">
                    {{ $t("fabricChangeTemplateButton") }}
                  </div></v-card-text
                >
              </v-card>
              <!-- GUMB PREDOGLED -->
              <v-card
                dark
                flat
                color="primary"
                class="ma-1 pa-1 hover-item white--text"
                :style="
                  $vuetify.breakpoint.width > 480
                    ? 'width: 68px; max-width: 68px'
                    : 'width: 38px; max-width: 38px'
                "
                @click="prepareImagePreview"
              >
                <v-card-text class="ma-0 pa-0 text-center">
                  <v-icon color="white">mdi-monitor-eye</v-icon>
                </v-card-text>
                <v-card-text
                  style="font-size: 10px"
                  class="ma-0 pa-0 font-weight-normal text-center white--text"
                  ><div class="headerClass">
                    {{ $t("fabricPreviewGroupControlsTitle") }}
                  </div></v-card-text
                >
              </v-card>
              <!-- GUMB PREDOGLED NA IZDELKU -->
              <v-card
                v-if="
                  $store.state.storePhotoGiftOrderDesign.canvasTemplates[
                    activeTab
                  ].finalPreview
                "
                dark
                flat
                color="primary"
                class="ma-1 pa-1 hover-item white--text"
                :style="
                  $vuetify.breakpoint.width > 480
                    ? 'width: 68px; max-width: 68px'
                    : 'width: 38px; max-width: 38px'
                "
                @click="preparePreview"
              >
                <v-card-text class="ma-0 pa-0 text-center">
                  <v-icon color="white">mdi-image-frame</v-icon>
                </v-card-text>
                <v-card-text
                  style="font-size: 10px"
                  class="ma-0 pa-0 font-weight-normal text-center white--text"
                  ><div class="headerClass">
                    {{ $t("userNewPhotoGiftOrderDesignItemPreview") }}
                  </div></v-card-text
                >
              </v-card>
              <!-- GUMB POMOČ -->
              <v-card
                v-if="
                  $store.state.storePhotoGiftOrderDesign.canvasTemplates[
                    activeTab
                  ].selected.instructions != ''
                "
                dark
                flat
                color="primary"
                class="ma-1 pa-1 hover-item white--text"
                :style="
                  $vuetify.breakpoint.width > 480
                    ? 'width: 68px; max-width: 68px'
                    : 'width: 38px; max-width: 38px'
                "
                @click="dialogMsg = true"
              >
                <v-card-text class="ma-0 pa-0 text-center">
                  <v-icon color="white">mdi-help-circle-outline</v-icon>
                </v-card-text>
                <v-card-text
                  style="font-size: 10px"
                  class="ma-0 pa-0 font-weight-normal text-center white--text"
                  ><div class="headerClass">
                    {{ $t("userNewPhotoGiftOrderDesignInstructions") }}
                  </div></v-card-text
                >
              </v-card>

              <!-- GUMB ZAKLJUČI NAROČILO -->
              <v-card
                color="secondary"
                class="ma-1 pa-1 hover-item white--text"
                :style="
                  $vuetify.breakpoint.width > 480
                    ? 'width: 68px; max-width: 68px'
                    : 'width: 58px; max-width: 58px'
                "
                @click="checkCurrentTemplate"
              >
                <v-card-text class="ma-0 pa-0 text-center">
                  <v-badge
                    v-if="
                      $store.state.storePhotoGiftOrderDesign.allowTemplateClones
                    "
                    color="success"
                  >
                    <template v-slot:badge>
                      {{ $store.state.storePhotoGiftOrderDesign.itemCopies }}
                      <span
                        v-show="
                          $store.state.storePhotoGiftOrderDesign
                            .maxTemplateClones > 0
                        "
                      >
                        /
                        {{
                          $store.state.storePhotoGiftOrderDesign
                            .maxTemplateClones
                        }}
                      </span>
                    </template>
                    <v-icon color="white">mdi-cart-arrow-right</v-icon>
                  </v-badge>
                  <v-icon v-else color="white">mdi-cart-arrow-right</v-icon>
                </v-card-text>
                <v-card-text
                  style="font-size: 10px"
                  class="ma-0 pa-0 font-weight-normal text-center white--text"
                  ><div class="headerClass">
                    {{ $t("userNewPhotoGiftOrderDesignFinalize") }}
                  </div></v-card-text
                >
              </v-card>
              <v-spacer></v-spacer>
            </v-toolbar>
          </v-card>
        </v-flex>

        <!-- PLEASE WAIT DIALOG -->
        <v-dialog
          v-model="dialogWait"
          persistent
          max-width="400"
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-card-title class="headline">{{
              $t("userNewOrderPleaseWaitTitle")
            }}</v-card-title>
            <v-card-text>
              {{ dialogWaitMsg }}
            </v-card-text>
            <v-card-text class="d-flex">
              <v-spacer></v-spacer>
              <v-progress-linear
                color="primary"
                height="10"
                indeterminate
              ></v-progress-linear>
              <v-spacer></v-spacer>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- TEMPLATE SELECTION DIALOG -->
        <dialog-template-selection
          v-model="showTemplateSelection"
          :templateVar="showTemplateSelectionArray"
          :desc="desc"
          @update:desc="desc = $event"
          @selectedId="changeTemplate($event)"
        ></dialog-template-selection>

        <!-- DIALOG COLOR PICKER -->
        <dialog-color-picker
          :active="dialogColorPickerActive"
          @clickYes="dialogColorPickerActive = false"
          icon="mdi-palette"
          :title="$t('fabricColorPickerTitle')"
          :gradient="dialogColorPickerGradient"
          @gradientChecked="
            dialogColorPickerGradient = $event;
            dialogColorPickerBackgroundColorApply();
          "
          :initColor="dialogColorPickerColor"
          @selectedColor="
            dialogColorPickerColor = $event;
            dialogColorPickerBackgroundColorApply();
          "
        ></dialog-color-picker>

        <!-- DIALOG VUE CROPPER BASIC -->
        <dialog-vue-cropper-basic
          v-model="showCropper"
          :cropperItem="
            $store.state.storePhotoGiftOrderDesign.currentImagePreview
          "
          :viewMode="computedViewMode"
          :scaleFactor="itemCanvasMF[activeTab] ? itemCanvasMF[activeTab] : 1"
          @croppedImage="cropFinal($event)"
        ></dialog-vue-cropper-basic>

        <!-- MSG DIALOG -->
        <dialog-basic-msg
          :active="dialogMsg"
          @clickYes="dialogMsg = false"
          icon="mdi-lightbulb-on-outline"
          :title="$t('msgAdvice')"
          :body="
            $store.state.storePhotoGiftOrderDesign.canvasTemplates[activeTab]
              .selected.instructions
          "
        ></dialog-basic-msg>

        <!-- MSG DIALOG MAC CANVAS ERROR -->
        <dialog-basic-msg
          :active="dialogMaxCanvas"
          @clickYes="dialogMaxCanvas = false"
          icon="mdi-alert"
          :title="$t('appWarningTitle')"
          :body="
            $store.state.storePhotoGiftOrderDesign.enableDeviceBasedEdit
              ? $t('userNewPhotoGiftOrderDesignMaxCanvasError1')
              : $t('userNewPhotoGiftOrderDesignMaxCanvasError2')
          "
        ></dialog-basic-msg>

        <!-- PIXABAY PATTERN SELECTION DIALOG -->
        <dialog-background-image-selection
          v-model="showPixabayBackgroundPatternSelection"
          startPixabaySearch="seamless"
          @selectedItem="addFromImageDBPixabayPattern($event)"
        ></dialog-background-image-selection>

        <!-- PIXABAY IMAGE SELECTION DIALOG -->
        <dialog-background-image-selection
          v-model="showPixabayBackgroundSelection"
          startPixabaySearch=""
          @selectedItem="addFromImageDBPixabay($event)"
        ></dialog-background-image-selection>

        <!-- IMAGE DATABASE LIVE SELECTION DIALOG -->
        <dialog-image-database-live-selection
          v-model="showImageDatabaseLiveSelection"
          mode="live"
          order="popular"
          :dType="dType"
          :dTitle="dTitle"
          :dIcon="dIcon"
          :pageSize="25"
          @selectedItem="addFromImageDB($event)"
          @customSticker="addNewCustomSticker($event)"
        ></dialog-image-database-live-selection>

        <dialog-image-database-live-selection
          v-if="
            $store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas
              .showStickerControls !== undefined
          "
          v-model="
            $store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas
              .showStickerControls
          "
          mode="edit"
          order="popular"
          :dType="G_IMAGE_DATABASE_TYPE_STICKERS"
          :dTitle="$t('fabricSelectStickerDialogTitle')"
          dIcon="mdi-sticker-emoji"
          :pageSize="25"
          :cIndex="0"
          :allowReplace="
            $store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas
              .allowReplace
          "
          @selectedItem="addStickerFromImageDB($event)"
        ></dialog-image-database-live-selection>

        <!-- DIALOG IMAGE PREVIEW -->
        <dialog-image-preview
          v-model="dialogImagePreview"
          :imagePreviewTemplate="imagePreviewTemplate"
          :imageItemPreviewTemplate="
            $store.state.storePhotoGiftOrderDesign.canvasTemplates[activeTab]
              .finalPreview
          "
        ></dialog-image-preview>

        <!-- COMPOSITE IMAGE PREVIEW DIALOG -->
        <v-dialog
          v-model="dialogPreview"
          persistent
          transition="dialog-bottom-transition"
          style="z-index: 2000"
          :fullscreen="true"
          :scrollable="true"
        >
          <v-card
            class="text-center"
            :class="
              getTheme() == 'dark' ? 'outlined elevation-0' : 'flat elevation-0'
            "
            :style="
              getTheme() == 'dark' ? '' : 'border-bottom: 1px solid lightgray'
            "
          >
            <v-card-title
              :style="
                getTheme() == 'dark'
                  ? 'background-color: #505050'
                  : 'background-color: white; border-bottom: 1px solid lightgray'
              "
              :class="getTheme() == 'dark' ? 'white--text' : '#505050--text'"
              class="title font-weight-regular pl-5 pr-3"
            >
              <v-icon
                :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
                class="mr-2"
                medium
                >mdi-image-outline</v-icon
              >
              {{ $t("fabricDialogPreviewOnItemTitle") }}
              <v-spacer></v-spacer>
              <v-btn
                text
                medium
                @click="dialogPreview = false"
                style="min-width: 0; width: 20px"
              >
                <v-icon
                  medium
                  :class="
                    getTheme() == 'dark' ? 'white--text' : 'primary--text'
                  "
                  >mdi-close-box</v-icon
                >
              </v-btn>
            </v-card-title>

            <!-- PREDOGLED SLIKA -->
            <v-card-text
              class="d-flex ma-0 pa-2"
              style="background-color: lightgray"
            >
              <div id="previewCanvas" class="d-flex" style="width: 100%">
                <v-spacer></v-spacer>
                <canvas
                  ref="fabricCanvasPreview"
                  style="object-fit: contain"
                ></canvas>
                <v-spacer></v-spacer>
              </div>
            </v-card-text>

            <!--<v-card-actions
              :class="getTheme() == 'dark' ? '#505050--text' : '#505050--text'"
              :style="
                getTheme() == 'dark'
                  ? 'background-color: whitesmoke; border-top: 1px solid lightgray;'
                  : 'background-color: white; border-top: 1px solid lightgray;'
              "
            >
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                class="my-1 mr-5"
                text
                @click="dialogPreview = false"
                >{{ $t("lmBtnClose") }}</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>-->
          </v-card>
        </v-dialog>

        <!-- RESET BUTTON CONFIRM DIALOG -->
        <dialog-basic-yes-no
          :active="dQReset"
          @clickYes="
            dQReset = false;
            showTemplateSelectionMode = 2;
            changeTemplate(0);
          "
          @clickNo="dQReset = false"
          icon="mdi-help"
          :title="$t('msgQuestion')"
          >{{
            $t("userNewPhotoGiftOrderDesignResetQuestion")
          }}</dialog-basic-yes-no
        >

        <!-- CUSTOM SIZE DIALOG -->
        <dialog-custom-size
          :active="customSizeDialog"
          @clickApply="applyCustomSize"
        ></dialog-custom-size>

        <!-- TAB CHANGE CONFIRM DIALOG -->
        <dialog-basic-yes-no
          :active="dQTabChange"
          @clickYes="
            dQTabChange = false;
            setActiveTab(currentIndex);
          "
          @clickNo="
            tab = activeTab;
            currentIndex = activeTab;
            dQTabChange = false;
          "
          icon="mdi-help"
          :title="$t('msgQuestion')"
          >{{
            $t("userNewPhotoGiftOrderDesignChangeTabQuestion")
          }}</dialog-basic-yes-no
        >

        <!-- TAB FINALIZE OR ADD NEW CONFIRM DIALOG -->
        <dialog-photo-gift-multiple
          :active="dQTabFinalizeMultiple"
          @clickBtn1="
            dQTabFinalizeMultiple = false;
            resetOrderFinalize();
          "
          @clickBtn2="createFreshCopy()"
          @clickBtn3="finalizeMultiple()"
          :btn2Text="$t('userNewPhotoGiftOrderDesignFinalizeMultipleBtn2')"
          :btn3Text="$t('userNewPhotoGiftOrderDesignFinalizeMultipleBtn3')"
          icon="mdi-help"
          :title="$t('msgQuestion')"
        ></dialog-photo-gift-multiple>

        <!-- FINALIZE ORDER CONFIRM DIALOG -->
        <dialog-basic-yes-no
          :active="dQFinalize"
          @clickYes="
            dQFinalize = false;
            checkOrderFinalize();
          "
          @clickNo="dQFinalize = false"
          icon="mdi-help"
          :title="$t('msgQuestion')"
          >{{
            $t("userNewPhotoGiftOrderDesignFinalizeQuestion")
          }}</dialog-basic-yes-no
        >

        <v-snackbar
          style="z-index: 3000"
          absolute
          v-model="$store.state.storeSnackbar.snackbar.active"
          :color="$store.state.storeSnackbar.snackbar.color"
          :timeout="$store.state.storeSnackbar.snackbar.timeout"
          >{{ $store.state.storeSnackbar.snackbar.message }}
        </v-snackbar>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import Panzoom from "@panzoom/panzoom";
import moment from "moment";
import "firebase/functions";
import firebase from "firebase/app"; // za servertimestamp
import { fabric } from "fabric";
import "fabric-customise-controls";
import * as c from "@/constants";
import * as helper from "@/mixins/modPhotoGiftOrderDesignHelper";
import * as fabricJs from "@/mixins/modFabricJsHelper";
import DialogBasicYesNo from "@/components/DialogBasicYesNo";
import DialogCustomSize from "@/components/DialogCustomSize";
import DialogShowGoBack from "@/components/DialogShowGoBack";
import DialogPhotoGiftMultiple from "@/components/DialogPhotoGiftMultiple";
import DialogTemplateSelection from "@/components/DialogTemplateSelection";
import DialogImagePreview from "@/components/DialogImagePreview";
import DialogBasicMsg from "@/components/DialogBasicMsg";
import DialogBackgroundImageSelection from "@/components/DialogBackgroundImageSelection";
import FabricBackgroundImageControlsCard from "@/components/FabricBackgroundImageControlsCard";
import FabricSimplePlaceholderImageControlsCard from "@/components/FabricSimplePlaceholderImageControlsCard";
import FabricSimpleFrameControlsCard from "@/components/FabricSimpleFrameControlsCard";
import DialogImageDatabaseLiveSelection from "@/components/DialogImageDatabaseLiveSelection";
import FabricTextControlsCard from "@/components/FabricTextControlsCard";
import {
  readNewSimpleFile,
  readNewSimpleExtraFile,
  readAndRotateUrlFile,
  readImageDimensionsWithSrc,
} from "@/mixins/modPhotoOrderUploadService";
import DialogVueCropperBasic from "@/components/DialogVueCropperBasic";
import DialogColorPicker from "@/components/DialogColorPicker";
import { lightenDarkenColor } from "@/mixins/utils";
import layout from "image-layout/layouts/fixed-partition";

export default {
  name: "userNewPhotoGiftOrderDesign",
  components: {
    DialogTemplateSelection,
    DialogBasicYesNo,
    DialogCustomSize,
    DialogShowGoBack,
    DialogImagePreview,
    DialogBasicMsg,
    DialogPhotoGiftMultiple,
    DialogVueCropperBasic,
    DialogColorPicker,
    DialogBackgroundImageSelection,
    DialogImageDatabaseLiveSelection,
    FabricBackgroundImageControlsCard,
    FabricSimplePlaceholderImageControlsCard,
    FabricTextControlsCard,
    FabricSimpleFrameControlsCard,
  },
  data() {
    return {
      overrideWidthFactor: 1, // začetni scale faktor
      overrideHeightFactor: 1,
      panzoom: {},
      cZoom: 1,
      cPan: {},
      fab: false,
      showGoBack: false,
      showGoBackCustomSize: false,
      defaultSimpleImageSettings: {
        stroke: "#FFFFFFFF",
        strokeWidth: 30,
        borderRadius: 20,
      },
      uploadReady: true,
      tab: 0,
      activeTab: 0,
      oldActiveTab: 0,
      currentIndex: 0,
      desc: false,
      winH: 0, // canvas area calculated height
      winW: 0, // canvas area calculated width
      itemPrintItemsTemp: [], // canvas simpleImages definition array
      itemCanvasMF: [], // canvas magnification calculation array
      itemsAvailable: false, // is there any images to be filled on canvas
      loadTemplateWithError: 0, // error count for template layers loading
      dialogMsg: false,
      dialogMsg2: false,
      dialogWait: false,
      dialogPreview: false,
      dialogImagePreview: false,
      customSizeDialog: false,
      dQReset: false,
      dQTabChange: false,
      dQTabFinalizeMultiple: false,
      dQFinalize: false,
      applyCustomSizeStart: true,
      dialogWaitMsg: "",
      canvasPreviewTemplate: null, // canvas za preview na izdelku
      imagePreviewTemplate: "",
      showTemplateSelection: false,
      showTemplateSelectionMode: 0,
      showTemplateSelectionArray: [],
      currentCompositePreview: {},
      canvasRatio: 1,
      checked: 0,
      cViewMode: 1,
      showCropper: false,
      isAllLoaded: 0,
      dialogColorPickerActive: false,
      dialogColorPickerGradient: true,
      dialogColorPickerColor: "#9575CDFF",
      showImageDatabaseLiveSelection: false,
      singleImageFile: {},
      showPixabayBackgroundPatternSelection: false,
      showPixabayBackgroundSelection: false,
      freeDrawingSettings: {
        strokeWidth: 20,
        strokeColor: "#00FF00FF",
        fillColor: "silver",
        shadowColor: "#000000FF",
        shadowBlur: 10,
      },
      imageSettings: {
        filter: 1,
        brightness: 0,
        contrast: 0,
      },
      cImageSettings: {
        filter: 1,
        brightness: 0,
        contrast: 0,
      },
      filterImageIndex: 0, // da imamo lahko fiter komponento enako za simple in frame slike
      filterImageSettings: [], // da imamo lahko fiter komponento enako za simple in frame slike
      dType: "",
      dTitle: "",
      dIcon: "",
      dialogMaxCanvas: false,
      isMaxCanvasLimit: false,
      showPrice: false, // če je darilni bon in ima generirano ceno, da vem ali prikazati opcijo cena on/off
      giftCardPriceToggle: true, // začetno stanje prikaza cene na darilnih bonih
    };
  },
  computed: {
    computedViewMode() {
      return this.cViewMode;
    },
  },
  methods: {
    giftCardPriceOnOff() {
      this.giftCardPriceToggle = !this.giftCardPriceToggle;

      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates.forEach(
        (x) => {
          x.canvas._objects.forEach((y) => {
            console.log(y);
            if (y.myType == "text" && y.mySubType == "giftCard") {
              if (y.textFunction == 10) {
                if (this.giftCardPriceToggle) {
                  y.text =
                    this.$t("fabricTextFunctionGiftCardUserCode") +
                    " " +
                    this.$store.state.storePhotoGiftOrderDesign
                      .itemGiftCardCode +
                    "  |  " +
                    this.$t("fabricTextFunctionGiftCardUserPrice") +
                    " " +
                    this.$store.state.storePhotoGiftOrderDesign.itemPrice +
                    " " +
                    this.$store.state.storeClient.client.environmentSettings
                      .currency +
                    "  |  " +
                    this.$t("fabricTextFunctionGiftCardUserValidTo") +
                    " " +
                    (this.$store.state.storePhotoGiftOrderDesign.validTo > 0
                      ? this.$store.state.storePhotoGiftOrderDesign.itemGiftCardValidTo.format(
                          this.$store.state.storeClient.client
                            .environmentSettings.dateFormat
                        )
                      : this.$t("settingsGiftCardTemplateValidInfinite"));
                } else {
                  y.text =
                    this.$t("fabricTextFunctionGiftCardUserCode") +
                    " " +
                    this.$store.state.storePhotoGiftOrderDesign
                      .itemGiftCardCode +
                    "  |  " +
                    this.$t("fabricTextFunctionGiftCardUserValidTo") +
                    " " +
                    (this.$store.state.storePhotoGiftOrderDesign.validTo > 0
                      ? this.$store.state.storePhotoGiftOrderDesign.itemGiftCardValidTo.format(
                          this.$store.state.storeClient.client
                            .environmentSettings.dateFormat
                        )
                      : this.$t("settingsGiftCardTemplateValidInfinite"));
                }
              } else if (y.textFunction == 15) {
                if (this.giftCardPriceToggle) {
                  y.text =
                    this.$store.state.storePhotoGiftOrderDesign
                      .itemGiftCardCode +
                    "  |  " +
                    this.$store.state.storePhotoGiftOrderDesign.itemPrice +
                    " " +
                    this.$store.state.storeClient.client.environmentSettings
                      .currency +
                    "  |  " +
                    (this.$store.state.storePhotoGiftOrderDesign.validTo > 0
                      ? this.$store.state.storePhotoGiftOrderDesign.itemGiftCardValidTo.format(
                          this.$store.state.storeClient.client
                            .environmentSettings.dateFormat
                        )
                      : this.$t("settingsGiftCardTemplateValidInfinite"));
                } else {
                  y.text =
                    this.$store.state.storePhotoGiftOrderDesign
                      .itemGiftCardCode +
                    "  |  " +
                    (this.$store.state.storePhotoGiftOrderDesign.validTo > 0
                      ? this.$store.state.storePhotoGiftOrderDesign.itemGiftCardValidTo.format(
                          this.$store.state.storeClient.client
                            .environmentSettings.dateFormat
                        )
                      : this.$t("settingsGiftCardTemplateValidInfinite"));
                }
              } else if (
                y.textFunction == 40 ||
                y.textFunction == 70 ||
                y.textFunction == 75
              ) {
                if (this.giftCardPriceToggle) {
                  y.opacity = 1;
                } else {
                  y.opacity = 0;
                }
              }
            }
          });
          x.canvas.requestRenderAll();
        }
      );
    },
    clickSimplePlaceholder(index2) {
      document.getElementById("canvas-0-input-" + index2).click();
    },
    deselectCanvas() {
      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas
        .discardActiveObject()
        .requestRenderAll();
    },
    async applyCustomSize() {
      if (
        this.$store.state.storePhotoGiftOrderDesign.customSizeWidth > 0 &&
        this.$store.state.storePhotoGiftOrderDesign.customSizeHeight > 0
      ) {
        this.customSizeDialog = false;

        // pretvorimo v 300 dpi px širina
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].selected.width =
          Math.round(
            (300 *
              (this.$store.state.storePhotoGiftOrderDesign.customSizeWidth *
                10)) /
              25.4
          );
        // pretvorimo v 300 dpi px višina
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].selected.height =
          Math.round(
            (300 *
              (this.$store.state.storePhotoGiftOrderDesign.customSizeHeight *
                10)) /
              25.4
          );

        /*console.log(
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
            .selected.width +
            " xx " +
            this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
              .selected.height
        );*/
        await this.prepareSingleCanvas(0, this.applyCustomSizeStart);
      } else
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: this.$t("dialogCustomSizeZeroError"),
        });
    },
    resetOrderFinalize() {
      this.$store.state.storePhotoGiftOrderDesign.multipleCopies.pop();

      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
        this.activeTab
      ].cUrl = "";
      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
        this.activeTab
      ].cUrl2 = "";
      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
        this.activeTab
      ].cUrlType = "";
    },
    finalizeMultiple() {
      this.dQTabFinalizeMultiple = false;
      this.$router.push({
        path: "/userNewPhotoGiftOrderFinalize",
      });
    },
    async createFreshCopy() {
      this.dQTabFinalizeMultiple = false;
      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
        this.activeTab
      ].files = [];
      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
        this.activeTab
      ].filesFrames = [];

      if (this.$store.state.storePhotoGiftOrderDesign.allowCustomSize) {
        this.customSizeDialog = true;
        this.applyCustomSizeStart = false;
      } else await this.prepareSingleCanvas(0, false);
    },
    swipe(direction) {
      this.oldActiveTab = this.activeTab;
      if (
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates.length >
          1 ||
        this.$store.state.storePhotoGiftOrderDesign.allowTemplateClones
      ) {
        this.iterateTemplateFrames();

        if (
          (direction == "Left" || direction == "Right") &&
          this.isAllLoaded != 0
        ) {
          this.$store.commit({
            type: "showSnackbar",
            color: "error",
            message: this.$t("userNewPhotoGiftOrderDesignSimpleError"),
          });
        } else if (direction == "Left") {
          if (
            this.currentIndex >=
            this.$store.state.storePhotoGiftOrderDesign.canvasTemplates.length -
              1
          ) {
            if (
              this.$store.state.storePhotoGiftOrderDesign.allowTemplateClones
            ) {
              if (this.$store.state.storePhotoGiftOrderDesign.allowCustomSize) {
                // custom size image handler
                this.dQTabFinalizeMultiple = true;

                this.generateActiveCanvasImage();
                this.generateActiveCustomSizeCanvasImage();

                setTimeout(() => {
                  this.$store.state.storePhotoGiftOrderDesign.itemCopies += 1;
                  this.$store.state.storePhotoGiftOrderDesign.itemFullPrice +=
                    Number(
                      this.$store.state.storePhotoGiftOrderDesign
                        .multipleCopies[
                        this.$store.state.storePhotoGiftOrderDesign
                          .multipleCopies.length - 1
                      ].price
                    );
                }, 500);
              } else {
                this.generateActiveCanvasImage();
                this.$store.state.storePhotoGiftOrderDesign.itemCopies += 1;
                if (
                  this.$store.state.storePhotoGiftOrderDesign
                    .maxTemplateClones == 0
                )
                  this.$store.state.storePhotoGiftOrderDesign.itemFullPrice +=
                    this.$store.state.storePhotoGiftOrderDesign.itemPrice;
                this.dQTabFinalizeMultiple = true;
              }
            } else this.dQFinalize = true;
          } else {
            this.dQTabChange = true;
            this.currentIndex++;
          }
        } else if (direction == "Right") {
          if (this.currentIndex > 0) {
            this.dQTabChange = true;
            this.currentIndex--;
          } else
            this.$store.commit({
              type: "showSnackbar",
              color: "warning",
              message: this.$t("userNewPhotoGiftOrderDesignSwipeRightError"),
            });
        }
      }
    },
    iterateTemplateFrames() {
      // preverimo, ali so izpolnjeni vsi templateImagePlaceholder-ji
      this.isAllLoaded = 0;

      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
        this.tab
      ].selected.items.forEach((x) => {
        if (!x.ready) this.isAllLoaded++;
      });

      // preverimo, ali so izpolnjeni vsi templateFramePlaceholder-ji
      if (this.isAllLoaded == 0) {
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas._objects.filter(
          (obj) => obj.myType == "templateFramePlaceholder"
        ).length > 0
          ? this.isAllLoaded++
          : (this.isAllLoaded = this.isAllLoaded);
      }
    },
    checkCurrentTemplate() {
      this.oldActiveTab = this.activeTab;
      if (
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.getObjects()
          .length > 0 ||
        (this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas
          .backgroundImage != 0 &&
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.getObjects()
            .length == 0)
      ) {
        this.iterateTemplateFrames();

        if (this.isAllLoaded == 0) {
          if (this.$store.state.storePhotoGiftOrderDesign.allowTemplateClones) {
            if (this.$store.state.storePhotoGiftOrderDesign.allowCustomSize) {
              // custom size image handler
              this.dQTabFinalizeMultiple = true;

              this.generateActiveCanvasImage();
              this.generateActiveCustomSizeCanvasImage();

              setTimeout(() => {
                this.$store.state.storePhotoGiftOrderDesign.itemCopies += 1;
                this.$store.state.storePhotoGiftOrderDesign.itemFullPrice +=
                  Number(
                    this.$store.state.storePhotoGiftOrderDesign.multipleCopies[
                      this.$store.state.storePhotoGiftOrderDesign.multipleCopies
                        .length - 1
                    ].price
                  );
              }, 500);
            } else {
              // retro photo image handler
              this.generateActiveCanvasImage();
              this.$store.state.storePhotoGiftOrderDesign.itemCopies += 1;
              if (
                this.$store.state.storePhotoGiftOrderDesign.maxTemplateClones ==
                0
              )
                this.$store.state.storePhotoGiftOrderDesign.itemFullPrice +=
                  this.$store.state.storePhotoGiftOrderDesign.itemPrice;
              this.dQTabFinalizeMultiple = true;
            }
          } else this.dQFinalize = true;
        } else {
          this.$store.commit({
            type: "showSnackbar",
            color: "error",
            message: this.$t("userNewPhotoGiftOrderDesignSimpleError"),
          });
        }
      } else
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: this.$t("userNewPhotoGiftOrderDesignSimpleError2"),
        });
    },
    clickTabChange(index) {
      if (index != this.activeTab) {
        if (
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
            this.activeTab
          ].cUrl == ""
        ) {
          this.iterateTemplateFrames();

          if (this.isAllLoaded == 0) {
            this.currentIndex = index;
            this.dQTabChange = true;
          } else {
            this.$store.commit({
              type: "showSnackbar",
              color: "error",
              message: this.$t("userNewPhotoGiftOrderDesignSimpleError"),
            });
            this.$nextTick(() => {
              setTimeout(() => {
                this.tab = this.activeTab;
              }, 0);
            });
          }
        } else {
          this.currentIndex = index;
          this.setActiveTab(this.currentIndex);
        }
      }
    },
    checkCheckedTemplates() {
      this.checked = 0;
      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates.forEach(
        (x) => {
          if (!x.cUrl || x.cUrl.length == 0) this.checked++;
        }
      );
    },
    checkOrderFinalize() {
      this.oldActiveTab = this.activeTab;
      this.generateActiveCanvasImage();
      this.checkCheckedTemplates();
      if (this.checked == 0) {
        this.$router.push({
          path: "/userNewPhotoGiftOrderFinalize",
        });
      } else {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: this.$t("userNewPhotoGiftOrderFinalizeError"),
        });
      }
    },
    generateActiveCanvasImage() {
      // če imamo darilni bon, premaknemo vsa generirana besedilna polja (koda, cena, veljavnost) na vrh, da niso prekrita z uporabnikovimi elementi
      if (this.$store.state.storePhotoGiftOrderDesign.superType == 4) {
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates.forEach(
          (x) => {
            x.canvas._objects.map((y) => {
              //console.log(y.text);
              if (y.myType == "text" && y.mySubType == "giftCard") {
                x.canvas.bringToFront(y);
              }
            });
          }
        );
      }

      // če je ozadje trasparentno, ga ne dodamo v končno sliko
      if (
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas
          .transparentBack ||
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas
          .overlayImage
      ) {
        // IZREZ TRANSPARENTNI PNG
        // pri png-jih naredimo dve sliki: za predogled in pravo za upload
        // pretvorimo fabricCanvas v cUrl image
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
          this.oldActiveTab
        ].cUrl = this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.toDataURL(
          {
            format: "png",
            quality: c.G_FILE_COMPRESSION,
          }
        );
        if (
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas
            .transparentBack
        ) {
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.backgroundImage = 0;
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.backgroundColor = 0;
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.requestRenderAll();
        }

        // naredimo izrez overlay imagea
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.overlayImage = 0;

        if (
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
            this.oldActiveTab
          ].selected.removeOverlay
        ) {
          // če je removeOverlay = true, samo shranimo brez overlay-a
          if (
            this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
              .canvas.transparentBack
          ) {
            // če je transparenca aktivna, shranimo kot png, sicer pa kot jpg
            this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
              this.oldActiveTab
            ].cUrl2 = this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.toDataURL(
              {
                format: "png",
                quality: c.G_FILE_COMPRESSION,
              }
            );
            this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
              this.oldActiveTab
            ].cUrlType = "png";
            console.log("REMOVE OVERLAY - PNG");
          } else {
            this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
              this.oldActiveTab
            ].cUrl = this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.toDataURL(
              {
                format: "jpeg",
                quality: c.G_FILE_COMPRESSION,
              }
            );
            this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
              this.oldActiveTab
            ].cUrlType = "jpg";
            console.log("REMOVE OVERLAY - JPG");
          }
        } else if (
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
            this.oldActiveTab
          ].selected.imageFgURL != ""
        ) {
          let vm = this;
          fabric.Image.fromURL(
            this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
              this.oldActiveTab
            ].selected.imageFg,
            function (img) {
              if (img._element == null) {
                console.log(
                  "ERROR fabric.Image.fromURL in generateActiveCanvasImage() function "
                );
                vm.$store.commit({
                  type: "showSnackbar",
                  color: "error",
                  message: this.$t("userNewPhotoGiftOrderLoadingImageError"),
                });
              }

              img.scaleToWidth(
                vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                  vm.oldActiveTab
                ].selected.width * vm.itemCanvasMF[vm.oldActiveTab]
              );
              img.scaleToHeight(
                vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                  vm.oldActiveTab
                ].selected.height * vm.itemCanvasMF[vm.oldActiveTab]
              );
              vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.setOverlayImage(
                img
              );
              vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.requestRenderAll();

              // pretvorimo fabricCanvas v cUrl image
              vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                vm.oldActiveTab
              ].cUrl2 = vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.toDataURL(
                {
                  format: "png",
                  quality: c.G_FILE_COMPRESSION,
                }
              );
              vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                vm.oldActiveTab
              ].cUrlType = "png";
              console.log("PNG activeTab, with OVERLAY", vm.oldActiveTab);
            },
            {
              // Needed to position backgroundImage at 0/0
              globalCompositeOperation: "destination-out",
              originX: "left",
              originY: "top",
              crossOrigin: "*",
            }
          );
        } else {
          // pretvorimo fabricCanvas v cUrl image
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
            this.oldActiveTab
          ].cUrl2 = this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.toDataURL(
            {
              format: "png",
              quality: c.G_FILE_COMPRESSION,
            }
          );
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
            this.oldActiveTab
          ].cUrlType = "png";
          console.log("PNG activeTab, no OVERLAY", this.activeTab);
        }
      } else {
        // pretvorimo fabricCanvas v cUrl image
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
          this.oldActiveTab
        ].cUrl = this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.toDataURL(
          {
            format: "jpeg",
            quality: c.G_FILE_COMPRESSION,
          }
        );
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
          this.oldActiveTab
        ].cUrlType = "jpg";
      }

      // create for multiple copies
      if (this.$store.state.storePhotoGiftOrderDesign.allowTemplateClones) {
        this.$store.state.storePhotoGiftOrderDesign.multipleCopies.push({
          copies: 1,
          cUrl: this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
            this.oldActiveTab
          ].cUrl,
          cUrl2:
            this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
              this.oldActiveTab
            ].cUrl2,
          cUrlType:
            this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
              this.oldActiveTab
            ].cUrlType,
        });
        console.log(
          "multiple",
          this.$store.state.storePhotoGiftOrderDesign.multipleCopies
        );
      }
      this.$forceUpdate();
    },
    generateActiveCustomSizeCanvasImage() {
      // priprava spremenljivk za generiranje slike v sliki za custom size image, uporabim kar spremenljivke za preview image
      if (this.canvasPreviewTemplate)
        this.canvasPreviewTemplate.canvas.dispose();
      this.canvasPreviewTemplate = {};

      // izračunamo katera je najmanjša slika primerna za tisk
      const tArr = this.$store.state.storeImageSize.imageSize.sort((a, b) =>
        a.name < b.name ? 1 : -1
      ); // sortiramo kar imena formatov (string)
      //console.log("tArr", tArr);

      const customSizeAspectRatio =
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].selected
          .width /
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].selected
          .height;

      let correctSize = {};

      let sameAR = true;
      tArr.forEach((x) => {
        let imageAspectRatio = Number(x.sizeX) / Number(x.sizeY);
        let w = Number(x.sizeX);
        let h = Number(x.sizeY);

        if (
          (customSizeAspectRatio >= 1 && imageAspectRatio < 1) ||
          (customSizeAspectRatio < 1 && imageAspectRatio >= 1)
        ) {
          // če aspect ratio ni enak, ga zamenjamo
          sameAR = false;
          w = Number(x.sizeY);
          h = Number(x.sizeX);
        }

        if (
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
            .selected.width <= w &&
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
            .selected.height <= h
        ) {
          correctSize = x;
          /*console.log(
            "Custom size: " +
              this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
                .selected.width +
              "x" +
              this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
                .selected.height +
              " ar => " +
              customSizeAspectRatio
          );
          console.log(
            "Available image size: " +
              x.sizeX +
              "x" +
              x.sizeY +
              " ar => " +
              imageAspectRatio
          );
          console.log(x.name);*/
        }
      });

      console.log("Format: ", correctSize.name, correctSize.price, sameAR);

      this.canvasPreviewTemplate.canvas = new fabric.Canvas(
        this.$refs.fabricCanvasPreview,
        {
          width: sameAR ? Number(correctSize.sizeX) : Number(correctSize.sizeY),
          height: sameAR
            ? Number(correctSize.sizeY)
            : Number(correctSize.sizeX),
          cRatio: Number(correctSize.sizeX) / Number(correctSize.sizeY),
          selection: false,
          enableRetinaScaling: false,
          renderOnAddRemove: true,
        }
      );

      this.canvasPreviewTemplate.canvas.setBackgroundColor(
        "rgba(255, 255, 255, 1)",
        this.canvasPreviewTemplate.canvas.requestRenderAll.bind(
          this.canvasPreviewTemplate.canvas
        )
      );

      let vm = this;
      fabric.Image.fromURL(
        this.$store.state.storePhotoGiftOrderDesign.multipleCopies[
          this.$store.state.storePhotoGiftOrderDesign.multipleCopies.length - 1
        ].cUrlType == "jpg"
          ? this.$store.state.storePhotoGiftOrderDesign.multipleCopies[
              this.$store.state.storePhotoGiftOrderDesign.multipleCopies
                .length - 1
            ].cUrl
          : this.$store.state.storePhotoGiftOrderDesign.multipleCopies[
              this.$store.state.storePhotoGiftOrderDesign.multipleCopies
                .length - 1
            ].cUrl2,
        (img) => {
          let img1 = img.set({
            width:
              this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
                .selected.width,
            height:
              this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
                .selected.height,
            evented: false,
            selectable: false,
            opacity: 1,
            left: sameAR
              ? Number(correctSize.sizeX) / 2
              : Number(correctSize.sizeY) / 2,
            top: sameAR
              ? Number(correctSize.sizeY) / 2
              : Number(correctSize.sizeX) / 2,
          });

          vm.canvasPreviewTemplate.canvas.insertAt(img1, 0).requestRenderAll();
        },
        {
          originX: "center",
          originY: "center",
          crossOrigin: "*",
        }
      );

      setTimeout(() => {
        this.$store.state.storePhotoGiftOrderDesign.multipleCopies[
          this.$store.state.storePhotoGiftOrderDesign.multipleCopies.length - 1
        ].cUrl = this.canvasPreviewTemplate.canvas.toDataURL({
          format: "jpeg",
          quality: c.G_FILE_COMPRESSION,
        });
        this.$store.state.storePhotoGiftOrderDesign.multipleCopies[
          this.$store.state.storePhotoGiftOrderDesign.multipleCopies.length - 1
        ].cUrlType = "jpg";
        this.$store.state.storePhotoGiftOrderDesign.multipleCopies[
          this.$store.state.storePhotoGiftOrderDesign.multipleCopies.length - 1
        ].size = correctSize.name;
        this.$store.state.storePhotoGiftOrderDesign.multipleCopies[
          this.$store.state.storePhotoGiftOrderDesign.multipleCopies.length - 1
        ].mySize =
          this.$store.state.storePhotoGiftOrderDesign.customSizeWidth +
          "x" +
          this.$store.state.storePhotoGiftOrderDesign.customSizeHeight;
        this.$store.state.storePhotoGiftOrderDesign.multipleCopies[
          this.$store.state.storePhotoGiftOrderDesign.multipleCopies.length - 1
        ].price =
          Number(correctSize.price) +
          Number(
            correctSize.price *
              this.$store.state.storePhotoGiftOrderDesign.itemPrice
          ) /
            100;
      }, 250);
    },
    setActiveTab(index) {
      this.oldActiveTab = this.activeTab;
      // naložimo nov canvas samo, če je klik na neaktivni tab
      if (index != this.activeTab) {
        this.generateActiveCanvasImage();
        if (
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[index]
            .cUrl &&
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[index]
            .cUrl.length > 0
        ) {
          this.prepareSingleCanvasView(index);
        } else {
          this.prepareSingleCanvas(index, false);
        }
      }
      this.activeTab = index;
      this.tab = index;
    },
    setCanvasFM(k, i) {
      // nastavimo faktor canvasa, na minimalno podprto px vrednost
      if (
        i.width > this.$store.state.maxCanvasSize.width ||
        i.height > this.$store.state.maxCanvasSize.height
      ) {
        this.isMaxCanvasLimit = true;
        let wPct =
          parseInt((this.$store.state.maxCanvasSize.width * 100) / i.width) /
          100;
        let hPct =
          parseInt((this.$store.state.maxCanvasSize.height * 100) / i.height) /
          100;
        let realPct = wPct < hPct ? wPct : hPct;
        console.log("Canvas zmanjšan na faktor", realPct);
        this.itemCanvasMF[k] = realPct;
      } else {
        console.log("Canvas ustreza podpori brskalnika.");
        this.isMaxCanvasLimit = false;
        this.itemCanvasMF[k] = 1;
      }
    },
    setItemsAvailable(i) {
      // ali imamo kaj nujnih slik v predlogi?
      this.itemsAvailable =
        ("rulesSimple" in
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i]
            .selected &&
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i]
            .selected.rulesSimple.length > 0) ||
        ("rulesFrames" in
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i]
            .selected &&
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i]
            .selected.rulesFrames.length > 0) ||
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i].selected
          .items.length > 0
          ? true
          : false;
    },
    async prepareSingleCanvas(i, start) {
      document.getElementById("mainCardText").style.height = this.winH + "px";
      console.log(
        "Canvas template loading ...",
        i,
        document.getElementById("mainCardText").offsetHeight
      );

      if (!start)
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.dispose();

      this.$refs.fabricCanvas == null;

      this.itemPrintItemsTemp[i] = []; // uporabnikove slike
      this.setCanvasFM(
        i,
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i].selected
      );

      // ali imamo tudi definirane slike na nov način?
      if (
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i].selected
          .rulesSimple
      ) {
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
          i
        ].selected.rulesSimple.forEach((y) => {
          this.itemPrintItemsTemp[i].push({
            left: y.left * this.overrideWidthFactor,
            top: y.top * this.overrideHeightFactor,
            width: y.width * this.overrideWidthFactor,
            height: y.height * this.overrideHeightFactor,
            angle: y.angle,
            clipP: y.clipP,
            strokeWidth: y.strokeWidth * this.overrideWidthFactor,
            stroke: y.stroke,
            borderRadius: y.borderRadius * this.overrideWidthFactor,
            ready: false,
          });

          /*console.log("----");
          console.log(
            this.$store.state.storePhotoGiftOrderDesign.overrideSizeWidth,
            this.$store.state.storePhotoGiftOrderDesign.overrideSizeHeight
          );
          console.log(
            "overrideFactors WH",
            this.overrideWidthFactor,
            this.overrideHeightFactor
          );
          console.log("y.width", y.width, y.height, y.left, y.top);
          console.log(
            "y.width2",
            y.width * this.overrideWidthFactor,
            y.height * this.overrideHeightFactor,
            y.left * this.overrideWidthFactor,
            y.top * this.overrideWidthFactor
          );*/
        });
      } else if (
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i].selected
          .rules.length > 0
      ) {
        let a2 =
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
            i
          ].selected.rules.split("|");

        a2.forEach((y) => {
          let y1 = y.split(",");
          this.itemPrintItemsTemp[i].push({
            left: y1[0],
            top: y1[1],
            width: y1[2],
            height: y1[3],
            angle: y1[4],
            clipP: y1[5],
            strokeWidth: y1[6],
            stroke: y1[7],
            borderRadius: y1[8],
            ready: false,
          });
        });
      } else {
        this.itemPrintItemsTemp[i] = []; // nimamo definiranih slik
      }

      // shranjena slika canvasa
      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i].cUrl = "";

      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
        i
      ].selected.cRatio =
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i].selected
          .width /
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i].selected
          .height;

      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
        i
      ].selected.items = this.itemPrintItemsTemp[i];

      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
        i
      ].allowBackground =
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
          i
        ].selected.allowBackground;

      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
        i
      ].mainImageBackground =
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
          i
        ].selected.mainImageBackground;

      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
        i
      ].allowImages =
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
          i
        ].selected.allowImages;
      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i].allowText =
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
          i
        ].selected.allowText;
      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
        i
      ].allowFreeDrawing =
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
          i
        ].selected.allowFreeDrawing;
      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
        i
      ].allowStickers =
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
          i
        ].selected.allowStickers;

      // ustvarimo nov fabricCanvas
      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas =
        new fabric.Canvas(this.$refs.fabricCanvas, {
          width:
            this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i]
              .selected.width * this.itemCanvasMF[i],
          height:
            this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i]
              .selected.height * this.itemCanvasMF[i],
          selection: false,
          enableRetinaScaling: false,
          showTextControls: false,
          showStickerControls: false,
          showBackgroundImageControls:
            this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i]
              .selected.rulesBackground.type == "image"
              ? true
              : false,
          backgroundImageBrightness: this.$store.state.storePhotoGiftOrderDesign
            .canvasTemplates[i].selected.rulesBackground.imageBrightness
            ? this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i]
                .selected.rulesBackground.imageBrightness
            : 0,
          backgroundImageContrast: this.$store.state.storePhotoGiftOrderDesign
            .canvasTemplates[i].selected.rulesBackground.imageContrast
            ? this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i]
                .selected.rulesBackground.imageContrast
            : 0,
          backgroundImageBlur: this.$store.state.storePhotoGiftOrderDesign
            .canvasTemplates[i].selected.rulesBackground.imageBlur
            ? this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i]
                .selected.rulesBackground.imageBlur
            : 0,
          backgroundImageFilter: this.$store.state.storePhotoGiftOrderDesign
            .canvasTemplates[i].selected.rulesBackground.imageFilter
            ? this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i]
                .selected.rulesBackground.imageFilter
            : 0,
          showImageControls: false,
          showFreeDrawingControls: false,
          showZoomControls: false,
          showFillBackControls: false,
          showSimplePlaceholderImageControls: false,
          showSimpleFrameRect: false,
          preserveObjectStacking: true,
        });

      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.on(
        "selection:cleared",
        function () {
          this.showTextControls = false;
          this.showStickerControls = false;
          this.showImageControls = false;
          this.showSimplePlaceholderImageControls = false;
          this.showSimpleFrameRect = false;
          //this.showBackgroundImageControls = this.canvasTemplates[i].canvas.backgroundImage != 0 ? true : false;
          console.log("Selection cleared.");
        }
      );

      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.on(
        "selection:created",
        function (e) {
          this.showTextControls = false;
          this.showImageControls = false;
          //this.showBackgroundImageControls = false;
          this.showFillBackControls = false;
          this.showStickerCControls = false;

          if (e.target.myType == "text") {
            this.showTextControls = true;
          } else if (e.target.myType == "templateFrame") {
            this.showImageControls = true;
          }
          console.log("Object selected.");
        }
      );

      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.on(
        "object:removed",
        function (e) {
          if (e.target.type == "i-text") {
            this.showTextControls = false;
            console.log("Text deleted.");
          } else if (e.target.myType == "sticker") {
            this.showStickerControls = false;
            console.log("Sticker deleted.");
          } else if (e.target.type == "group" || e.target.type == "image") {
            this.showImageControls = false;
            console.log("Image deleted.");
          }
        }
      );

      /***let vm = this;
      this.canvasTemplates[i].canvas.on("path:created", function(e) {
        e.path.fill = vm.freeDrawingSettings.fillColor;
      });*/

      if (!start) this.setItemsAvailable(i);

      // najprej uveljavimo dimenzije za width, da bomo potem lahko izračunali še height
      console.log("winSize", this.winW, this.winH);
      console.log(
        "canvasSize",
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i].selected
          .width,
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i].selected
          .height
      );
      console.log(
        "realCanvasSize",
        this.$refs.fabricCanvas.width,
        this.$refs.fabricCanvas.height
      );

      let rw,
        rh = 0;

      rw = this.winW - (this.$vuetify.breakpoint.mdAndUp ? 25 : 10);
      rh =
        rw /
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i].selected
          .cRatio;

      if (rh > this.winH) {
        rh = this.winH - (this.$vuetify.breakpoint.mdAndUp ? 25 : 10);
        rw =
          rh *
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i]
            .selected.cRatio;
      }

      // če je canvas manjši od prostora, potem ga prilagodimo na original dimenzije, da ni raztegnjen
      if (
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas
          .width < rw &&
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas
          .height < rh
      ) {
        rw =
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas
            .width;
        rh =
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas
            .height;
      }

      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.setDimensions(
        {
          width: rw + "px",
          height: rh + "px",
        },
        { cssOnly: true }
      );

      console.log("rw", rw);
      console.log("rh", rh);

      this.dialogWait = true;
      this.loadTemplateWithError = 0;

      this.dialogWaitMsg = this.$t(
        "userNewPhotoGiftOrderLoadingBackgroundImage"
      );
      this.loadTemplateWithError += await helper.setBackgroundLayer(
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates,
        i,
        this.itemCanvasMF[i]
      );

      if (
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i].selected
          .items.length > 0
      ) {
        this.dialogWaitMsg = this.$t(
          "userNewPhotoGiftOrderLoadingTemplateImages"
        );
        await helper.setTemplatePlaceholderImages(
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates,
          i,
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i]
            .selected.items,
          this.itemCanvasMF[i],
          this.$vuetify.breakpoint.smAndUp
        );
      }

      this.dialogWaitMsg = this.$t("userNewPhotoGiftOrderLoadingMiddleImage");
      this.loadTemplateWithError += await helper.setMiddleLayer(
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates,
        i,
        this.itemCanvasMF[i]
      );

      this.dialogWaitMsg = this.$t("userNewPhotoGiftOrderLoadingOverlayImage");
      this.loadTemplateWithError += await helper.setOverlayLayer(
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates,
        i,
        this.itemCanvasMF[i]
      );

      // morebitni okvirji
      if (
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i].selected
          .rulesFrames.length > 0
      ) {
        this.dialogWaitMsg = this.$t(
          "userNewPhotoGiftOrderLoadingTemplateImages"
        );
        await Promise.all(
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
            i
          ].selected.rulesFrames.map(async (z, index) => {
            console.log("TEMPLATE FRAME ADDED", z);
            await fabricJs.addFrame(
              z,
              this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i]
                .selected,
              this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0],
              this.$vuetify.breakpoint,
              0,
              index,
              this.itemCanvasMF[i]
            );
          })
        );
      }

      if (
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i].selected
          .rulesStickers.length > 0
      ) {
        this.dialogWaitMsg = this.$t("userNewPhotoGiftOrderLoadingStickers");

        // morebitne nalepke
        await Promise.all(
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
            i
          ].selected.rulesStickers.map(async (z) => {
            await fabricJs.addSticker(
              z,
              this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i]
                .selected,
              this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0],
              false,
              this.$vuetify.breakpoint,
              false,
              this.itemCanvasMF[i]
            );
          })
        );
      }

      if (
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i].selected
          .rulesText.length > 0
      ) {
        this.dialogWaitMsg = this.$t("userNewPhotoGiftOrderLoadingText");
        console.log(this.$store.state.storePhotoGiftOrderDesign);
        // morebitno besedilo
        await Promise.all(
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
            i
          ].selected.rulesText.map(async (z) => {
            this.$store.state.storePhotoGiftOrderDesign.itemGiftCardCode =
              Math.random().toString(36).slice(-5).toUpperCase(); // generiramo kodo, če gre za darilni bon

            // generiramo veljavnost, če gre za darilni bon, za neomejeno prištejemo 1000 let
            if (this.$store.state.storePhotoGiftOrderDesign.validTo > 0) {
              this.$store.state.storePhotoGiftOrderDesign.itemGiftCardValidTo =
                moment().add(
                  Number(this.$store.state.storePhotoGiftOrderDesign.validTo),
                  "days"
                );
            } else
              this.$store.state.storePhotoGiftOrderDesign.itemGiftCardValidTo =
                moment().add(1000, "years");

            // določimo besedilo glede na funkcijo (darilni boni)
            if (z.textFunction == 10) {
              this.showPrice = true;
              // koda + vrednost + veljavnost
              z.text =
                this.$t("fabricTextFunctionGiftCardUserCode") +
                " " +
                this.$store.state.storePhotoGiftOrderDesign.itemGiftCardCode +
                "  |  " +
                this.$t("fabricTextFunctionGiftCardUserPrice") +
                " " +
                this.$store.state.storePhotoGiftOrderDesign.itemPrice +
                " " +
                this.$store.state.storeClient.client.environmentSettings
                  .currency +
                "  |  " +
                this.$t("fabricTextFunctionGiftCardUserValidTo") +
                " " +
                (this.$store.state.storePhotoGiftOrderDesign.validTo > 0
                  ? this.$store.state.storePhotoGiftOrderDesign.itemGiftCardValidTo.format(
                      this.$store.state.storeClient.client.environmentSettings
                        .dateFormat
                    )
                  : this.$t("settingsGiftCardTemplateValidInfinite"));
            }
            if (z.textFunction == 15) {
              this.showPrice = true;
              // koda + vrednost + veljavnost
              z.text =
                this.$store.state.storePhotoGiftOrderDesign.itemGiftCardCode +
                "  |  " +
                this.$store.state.storePhotoGiftOrderDesign.itemPrice +
                " " +
                this.$store.state.storeClient.client.environmentSettings
                  .currency +
                "  |  " +
                (this.$store.state.storePhotoGiftOrderDesign.validTo > 0
                  ? this.$store.state.storePhotoGiftOrderDesign.itemGiftCardValidTo.format(
                      this.$store.state.storeClient.client.environmentSettings
                        .dateFormat
                    )
                  : this.$t("settingsGiftCardTemplateValidInfinite"));
            } else if (z.textFunction == 20) {
              // koda + veljavnost
              z.text =
                this.$t("fabricTextFunctionGiftCardUserCode") +
                " " +
                this.$store.state.storePhotoGiftOrderDesign.itemGiftCardCode +
                "  |  " +
                this.$t("fabricTextFunctionGiftCardUserValidTo") +
                " " +
                (this.$store.state.storePhotoGiftOrderDesign.validTo > 0
                  ? this.$store.state.storePhotoGiftOrderDesign.itemGiftCardValidTo.format(
                      this.$store.state.storeClient.client.environmentSettings
                        .dateFormat
                    )
                  : this.$t("settingsGiftCardTemplateValidInfinite"));
            } else if (z.textFunction == 25) {
              // koda + veljavnost
              z.text =
                this.$store.state.storePhotoGiftOrderDesign.itemGiftCardCode +
                "  |  " +
                (this.$store.state.storePhotoGiftOrderDesign.validTo > 0
                  ? this.$store.state.storePhotoGiftOrderDesign.itemGiftCardValidTo.format(
                      this.$store.state.storeClient.client.environmentSettings
                        .dateFormat
                    )
                  : this.$t("settingsGiftCardTemplateValidInfinite"));
            } else if (z.textFunction == 30) {
              z.text =
                this.$t("fabricTextFunctionGiftCardUserCode") +
                " " +
                this.$store.state.storePhotoGiftOrderDesign.itemGiftCardCode;
            } else if (z.textFunction == 40) {
              this.showPrice = true;
              z.text =
                this.$t("fabricTextFunctionGiftCardUserPrice") +
                " " +
                this.$store.state.storePhotoGiftOrderDesign.itemPrice +
                " " +
                this.$store.state.storeClient.client.environmentSettings
                  .currency;
            } else if (z.textFunction == 50) {
              z.text =
                this.$t("fabricTextFunctionGiftCardUserValidTo") +
                " " +
                (this.$store.state.storePhotoGiftOrderDesign.validTo > 0
                  ? this.$store.state.storePhotoGiftOrderDesign.itemGiftCardValidTo.format(
                      this.$store.state.storeClient.client.environmentSettings
                        .dateFormat
                    )
                  : this.$t("settingsGiftCardTemplateValidInfinite"));
            } else if (z.textFunction == 60) {
              z.text =
                this.$store.state.storePhotoGiftOrderDesign.itemGiftCardCode;
            } else if (z.textFunction == 70) {
              this.showPrice = true;
              z.text =
                this.$store.state.storePhotoGiftOrderDesign.itemPrice +
                " " +
                this.$store.state.storeClient.client.environmentSettings
                  .currency;
            } else if (z.textFunction == 75) {
              this.showPrice = true;
              z.text = String(
                this.$store.state.storePhotoGiftOrderDesign.itemPrice
              );
            } else if (z.textFunction == 80) {
              z.text =
                this.$store.state.storePhotoGiftOrderDesign.validTo > 0
                  ? this.$store.state.storePhotoGiftOrderDesign.itemGiftCardValidTo.format(
                      this.$store.state.storeClient.client.environmentSettings
                        .dateFormat
                    )
                  : this.$t("settingsGiftCardTemplateValidInfinite");
            }

            await fabricJs.addText(
              this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0],
              this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i]
                .selected,
              z,
              this.fonts,
              this.textBrushes,
              this.textBrush,
              z.text,
              this.$vuetify.breakpoint,
              false,
              false,
              this.itemCanvasMF[i],
              "giftCard"
            );
          })
        );
      }

      this.dialogWait = false;

      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.requestRenderAll();

      // je prišlo do kakšnih napak?
      if (this.loadTemplateWithError > 0) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message:
            this.$t("userNewPhotoGiftOrderLoadingError") +
            " (" +
            this.loadTemplateWithError +
            ")",
        });
      }

      /*console.log(
        "prepareSingleCanvas",
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates
      );
      console.log(
        "obj1",
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas
          ._objects
      );*/

      console.log(
        "Canvas template loaded",
        i,
        this.itemPrintItemsTemp,
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i]
      );

      // če je skipEdit pri darilnih bonih, ga damo takoj v košarico
      if (this.$store.state.storePhotoGiftOrderDesign.skipEdit) {
        this.checkOrderFinalize();
      }
    },
    async prepareSingleCanvasView(i) {
      console.log("SINGLE CANVAS VIEW", i);

      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.dispose();

      this.$refs.fabricCanvas == null;
      this.setCanvasFM(
        i,
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i].selected
      );

      // ustvarimo nov fabricCanvas
      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas =
        new fabric.Canvas(this.$refs.fabricCanvas, {
          width:
            this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i]
              .selected.width * this.itemCanvasMF[i],
          height:
            this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i]
              .selected.height * this.itemCanvasMF[i],
          selection: false,
          enableRetinaScaling: false,
          preserveObjectStacking: true,
        });

      this.itemsAvailable = false;

      let rw,
        rh = 0;

      rw = this.winW - (this.$vuetify.breakpoint.mdAndUp ? 25 : 10);
      rh =
        rw /
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i].selected
          .cRatio;

      if (rh > this.winH) {
        rh = this.winH - (this.$vuetify.breakpoint.mdAndUp ? 25 : 10);
        rw =
          rh *
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i]
            .selected.cRatio;
      }

      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.setDimensions(
        {
          width: rw + "px",
          height: rh + "px",
        },
        { cssOnly: true }
      );

      console.log("rw", rw);
      console.log("rh", rh);

      /*      this.dialogWait = true;

      this.dialogWaitMsg = this.$t(
        "userNewPhotoGiftOrderLoadingBackgroundImage"
      );
      this.loadTemplateWithError += await helper.setBackgroundLayer(
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates,
        i,
        this.itemCanvasMF[i]
      );

      this.dialogWait = false;*/

      this.dialogWait = true;
      this.dialogWaitMsg = this.$t("userNewPhotoGiftOrderLoadingTemplateImage");

      let vm = this;
      fabric.Image.fromURL(
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i].cUrl,
        (img) => {
          if (img._element == null) {
            console.log(
              "ERROR fabric.Image.fromURL in prepareSingleCanvasView() function "
            );
            vm.$store.commit({
              type: "showSnackbar",
              color: "error",
              message: this.$t("userNewPhotoGiftOrderLoadingImageError"),
            });
          }

          img.scaleToWidth(
            vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i]
              .selected.width * vm.itemCanvasMF[i]
          );
          img.scaleToHeight(
            vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[i]
              .selected.height * vm.itemCanvasMF[i]
          );

          vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.setBackgroundImage(
            img,
            vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.requestRenderAll.bind(
              vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
                .canvas
            ),
            { crossOrigin: "*" }
          );

          vm.dialogWait = false;
        },
        {
          // Needed to position backgroundImage at 0/0
          originX: "left",
          originY: "top",
          crossOrigin: "*",
        }
      );

      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.requestRenderAll();

      console.log(
        "prepareSingleCanvasView",
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates
      );
    },
    async changeTemplate(id) {
      console.log("id", id);
      console.log("showTemplateSelectionMode", this.showTemplateSelectionMode);

      if (this.showTemplateSelectionMode == 1) {
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
          this.showTemplateSelectionIndex
        ].selected = this.showTemplateSelectionArray.filter(
          (x) => x.id == id
        )[0];
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
          this.showTemplateSelectionIndex
        ].files = [];
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
          this.showTemplateSelectionIndex
        ].filesFrames = [];

        this.checkOverrideSize();
        await this.prepareSingleCanvas(this.showTemplateSelectionIndex, false);
      } else if (this.showTemplateSelectionMode == 2) {
        // handle reload current canvas
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
          this.activeTab
        ].files = [];
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
          this.activeTab
        ].filesFrames = [];

        if (this.$store.state.storePhotoGiftOrderDesign.allowCustomSize) {
          this.customSizeDialog = true;
          this.applyCustomSizeStart = false;
        } else {
          //this.checkOverrideSize();
          await this.prepareSingleCanvas(this.activeTab, false);
        }
      } else {
        /*this.canvasTemplates[
          this.showTemplateSelectionIndex
        ].selected = this.showTemplateSelectionArray.filter(
          (x) => x.id == id
        )[0];
        this.canvasTemplates[this.showTemplateSelectionIndex].files = [];
        this.canvasTemplates[this.showTemplateSelectionIndex].filesFrames = [];

        let full = true;
        this.canvasTemplates.map((x) => {
          if (Object.keys(x.selected).length == 0) full = false;
        });
        if (full) {
          this.SET_CANVAS_TEMPLATES(this.canvasTemplates);
          this.SET_ITEM_CATEGORY(this.itemCategory);
          this.SET_ITEM_SUB_CATEGORY(this.itemSubCategory);
          this.$router.push({
            path: "/userNewPhotoGiftOrderDesign",
          });
          //await this.prepareCanvas();
          //this.e1++;
        }*/
      }
      this.showTemplateSelection = false;
    },
    serveTemplateSelection(i) {
      this.showTemplateSelectionMode = i;
      this.showTemplateSelectionIndex = this.activeTab;
      this.showTemplateSelection = true;

      if (
        i == 1 &&
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates.length == 1
      ) {
        this.showTemplateSelectionArray =
          this.$store.state.storeImageTemplate.tempStartTemplateItemsArray;
      } else {
        this.showTemplateSelectionArray =
          this.$store.state.storeImageTemplate.imageMultipleCanvasFilteredTemplate[
            this.activeTab
          ];
      }
    },
    prepareImagePreview() {
      this.dialogImagePreview = true;

      // priprava slike za preview
      this.imagePreviewTemplate =
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.toDataURL(
          {
            format: "jpeg",
            quality: c.G_FILE_COMPRESSION,
          }
        );
    },
    preparePreview() {
      this.dialogPreview = true;

      // priprava slike za preview na izdelku
      if (this.canvasPreviewTemplate)
        this.canvasPreviewTemplate.canvas.dispose();
      this.canvasPreviewTemplate = {};

      let tempBack =
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas
          .backgroundImage;
      let tempColor =
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas
          .backgroundColor;

      if (
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas
          .transparentBack
      ) {
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.backgroundImage = 0;
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.backgroundColor = 0;
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.requestRenderAll();
      }

      if (
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
          this.activeTab
        ].selected.imageFgURL != ""
      ) {
        let vm = this;
        fabric.Image.fromURL(
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
            this.activeTab
          ].selected.imageFg,
          function (img) {
            if (img._element == null) {
              console.log(
                "ERROR fabric.Image.fromURL in preparePreview() function "
              );
              vm.$store.commit({
                type: "showSnackbar",
                color: "error",
                message: this.$t("userNewPhotoGiftOrderLoadingImageError"),
              });
            }

            img.scaleToWidth(
              vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                vm.activeTab
              ].selected.width * vm.itemCanvasMF[vm.activeTab]
            );
            img.scaleToHeight(
              vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                vm.activeTab
              ].selected.height * vm.itemCanvasMF[vm.activeTab]
            );
            vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.setOverlayImage(
              img
            );
            vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.requestRenderAll();
          },
          {
            // Needed to position backgroundImage at 0/0
            globalCompositeOperation: "destination-out",
            originX: "left",
            originY: "top",
            crossOrigin: "*",
          }
        );
      }

      setTimeout(() => {
        // poiščemo koordinate za izbrano kodo
        let cArray =
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
            this.activeTab
          ].codesArray.filter((item) => {
            return (
              item.code ==
              this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                this.activeTab
              ].selected.code
            );
          });
        //console.log("cArray", item.imageAspectRatio);

        this.currentCompositePreview = {
          image:
            this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
              this.activeTab
            ].image,
          imageWidth:
            this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
              this.activeTab
            ].imageWidth,
          imageHeight:
            this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
              this.activeTab
            ].imageHeight,
          canvasImage:
            this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
              .canvas.transparentBack ||
            this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
              .canvas.overlayImage
              ? this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.toDataURL(
                  {
                    format: "png",
                    quality: c.G_FILE_COMPRESSION,
                  }
                )
              : this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.toDataURL(
                  {
                    format: "jpeg",
                    quality: c.G_FILE_COMPRESSION,
                  }
                ),
          canvasImageCoords: cArray[0].coordinates,
          imageAspectRatio:
            this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
              this.activeTab
            ].imageAspectRatio,
        };

        if (
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas
            .transparentBack
        ) {
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.backgroundImage =
            tempBack;
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.backgroundColor =
            tempColor;
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.requestRenderAll();
        }

        this.canvasPreviewTemplate.canvas = new fabric.Canvas(
          this.$refs.fabricCanvasPreview,
          {
            width: this.currentCompositePreview.imageWidth,
            height: this.currentCompositePreview.imageHeight,
            cRatio: this.currentCompositePreview.imageAspectRatio,
            selection: false,
            enableRetinaScaling: false,
            renderOnAddRemove: true,
          }
        );

        this.canvasPreviewTemplate.canvas.setBackgroundImage(
          this.currentCompositePreview.image,
          this.canvasPreviewTemplate.canvas.requestRenderAll.bind(
            this.canvasPreviewTemplate.canvas
          ),
          {
            // Needed to position backgroundImage at 0/0
            originX: "left",
            originY: "top",
            crossOrigin: "*",
          }
        );

        if (
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
            this.activeTab
          ].selected.imageFgURL != ""
        ) {
          fabric.Image.fromURL(
            this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
              this.activeTab
            ].selected.imageFg,
            function (img) {
              if (img._element == null) {
                console.log(
                  "ERROR fabric.Image.fromURL in preparePreview() function "
                );
                vm.$store.commit({
                  type: "showSnackbar",
                  color: "error",
                  message: this.$t("userNewPhotoGiftOrderLoadingImageError"),
                });
              }

              img.scaleToWidth(
                vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                  vm.activeTab
                ].selected.width * vm.itemCanvasMF[vm.activeTab]
              );
              img.scaleToHeight(
                vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                  vm.activeTab
                ].selected.height * vm.itemCanvasMF[vm.activeTab]
              );
              vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.setOverlayImage(
                img
              );
              vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.requestRenderAll();
            },
            {
              // Needed to position backgroundImage at 0/0
              originX: "left",
              originY: "top",
              crossOrigin: "*",
            }
          );
        }

        // najprej uveljavimo dimenzije za width, da bomo potem lahko izračunali še height
        this.canvasPreviewTemplate.canvas.setDimensions(
          { width: "100%", height: "1px" },
          { cssOnly: true }
        );

        // pridobimo realni width
        let rw =
          document.getElementById("previewCanvas").offsetWidth /
          this.canvasPreviewTemplate.canvas.cRatio;

        // pridobimo realni height
        let rh =
          this.$vuetify.breakpoint.height /
          (this.canvasPreviewTemplate.canvas.height /
            this.canvasPreviewTemplate.canvas.width);

        /*console.log(
          "cRatio",
          this.canvasPreviewTemplate.canvas.cRatio,
          "canvas.width => ",
          this.canvasPreviewTemplate.canvas.width,
          "canvas.height => ",
          this.canvasPreviewTemplate.canvas.height,
          "rw => ",
          rw
        );
        console.log(
          "offsetWidth => ",
          document.getElementById("previewCanvas").offsetWidth
        );
        console.log("breakpoint.height => ", this.$vuetify.breakpoint.height);*/
        console.log("rw", rw, "rh", rh);

        if (
          this.canvasPreviewTemplate.canvas.width <
            this.$vuetify.breakpoint.width &&
          this.canvasPreviewTemplate.canvas.height <
            this.$vuetify.breakpoint.height
        ) {
          this.canvasPreviewTemplate.canvas.setDimensions(
            {
              width: this.canvasPreviewTemplate.canvas.width + "px",
              height: this.canvasPreviewTemplate.canvas.height + "px",
            },
            { cssOnly: true }
          );
          console.log("1");
        } else if (
          this.canvasPreviewTemplate.canvas.height >
          this.$vuetify.breakpoint.height
        ) {
          // če je potreben scroll potem nastavimo višino kot glavno stranico za prikaz
          this.canvasPreviewTemplate.canvas.setDimensions(
            {
              width: "100%",
              height: this.$vuetify.breakpoint.height - 80 + "px",
            },
            { cssOnly: true }
          );
          console.log("2");
        }
        // sicer izrišemo glavno stranico kot width
        // dodamo še izračunani height
        else {
          this.canvasPreviewTemplate.canvas.setDimensions(
            {
              width: "100%",
              height: this.canvasPreviewTemplate.canvas.height - 80 + "px",
            },
            { cssOnly: true }
          );
          console.log("3");
        }

        let vm = this;
        fabric.Image.fromURL(
          this.currentCompositePreview.canvasImage,
          function (img) {
            if (img._element == null) {
              console.log(
                "ERROR fabric.Image.fromURL in preparePreview() function "
              );
              vm.$store.commit({
                type: "showSnackbar",
                color: "error",
                message: this.$t("userNewPhotoGiftOrderLoadingImageError"),
              });
            }

            let img1 = img.set({
              left: vm.currentCompositePreview.canvasImageCoords.left,
              top: vm.currentCompositePreview.canvasImageCoords.top,
              originX: "center",
              originY: "center",
              selectable: false,
            });

            img1.scaleToWidth(
              vm.currentCompositePreview.canvasImageCoords.width
            );

            // kot spremenimo na koncu, sicer ne scaleToWidth ni ok
            img1.set({
              angle: vm.currentCompositePreview.canvasImageCoords.angle,
            });

            vm.canvasPreviewTemplate.canvas.add(img1).requestRenderAll();
          },
          { crossOrigin: "anonymous" }
        );
      }, 0);
    },
    filesChange(item, item2, index2) {
      this.$store.state.storePhotoGiftOrderDesign.iIndex = index2;
      this.$store.state.storePhotoGiftOrderDesign.cIndexMode =
        "addNewTemplateImage";

      item.files[index2] = document.getElementById(
        "canvas-0-input-" + index2
      ).files[0];

      readNewSimpleFile(item.files[index2]).then((img) => {
        this.$store.state.storePhotoGiftOrderDesign.currentImagePreview = {
          image: img.image,
          index: this.activeTab,
          index2: index2,
          clipP: item2.clipP,
          aspectRatio: Number(item2.width) / Number(item2.height),
          width: Number(item2.width) - Number(item2.strokeWidth) * 2,
          height: Number(item2.height) - Number(item2.strokeWidth) * 2,
          left: Number(item2.left),
          top: Number(item2.top),
          angle: Number(item2.angle),
          stroke: item2.stroke,
          strokeWidth: Number(item2.strokeWidth),
          borderRadius: Number(item2.borderRadius),
          scaleX: 1,
          scaleY: 1,
        };
        this.cViewMode = 1;
        this.showCropper = true;
      });
    },
    filesFramesChange(item, item2, index2) {
      this.$store.state.storePhotoGiftOrderDesign.iIndex = index2;
      this.$store.state.storePhotoGiftOrderDesign.cIndexMode =
        "addNewFrameTemplateImage";

      item.filesFrames[index2] = document.getElementById(
        "canvas-0-input-frame-" + index2
      ).files[0];

      readNewSimpleFile(item.filesFrames[index2]).then((img) => {
        this.$store.state.storePhotoGiftOrderDesign.currentImagePreview = {
          image: img.image,
          imageFrame: item2.image,
          index: this.activeTab,
          index2: index2,
          clipP: item2.coordinates.mode,
          rotated: item2.rotated,
          coordinates: item2.coordinates,
          aspectRatio: item2.rotated
            ? item2.coordinates.height / item2.coordinates.width
            : item2.coordinates.width / item2.coordinates.height,
          width: item2.rotated
            ? item2.coordinates.height
            : item2.coordinates.width,
          height: item2.rotated
            ? item2.coordinates.width
            : item2.coordinates.height,
          fWidth: Number(item2.width),
          fHeight: Number(item2.height),
          left: Number(item2.left),
          top: Number(item2.top),
          angle: Number(item2.angle),
          scaleX: item2.scaleX,
          scaleY: item2.scaleY,
        };
        this.cViewMode = 1;
        this.showCropper = true;
      });
    },
    cropFinal(image) {
      if (
        this.$store.state.storePhotoGiftOrderDesign.currentImagePreview.hasOwnProperty(
          "index2"
        )
      ) {
        if (
          this.$store.state.storePhotoGiftOrderDesign.cIndexMode ==
          "addNewTemplateImage"
        ) {
          console.log(
            "USER TEMPLATE IMAGE",
            this.$store.state.storePhotoGiftOrderDesign.iIndex,
            this.$store.state.storePhotoGiftOrderDesign.currentImagePreview
              .index,
            this.$store.state.storePhotoGiftOrderDesign.currentImagePreview
              .index2,
            image
          );

          // izbrišemo vse objekte z istima indeksoma
          let rectanglegroups =
            this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas._objects.filter(
              (obj) =>
                obj.iIndex ==
                  this.$store.state.storePhotoGiftOrderDesign.iIndex &&
                (obj.myType == "templatePlaceholder" ||
                  obj.myType == "templateImage")
            );

          rectanglegroups.map((obj) => {
            try {
              this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.remove(
                obj
              );
            } catch (error) {
              console.log(error);
            }
          });

          /*// izrez predefinirane template slike
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
            this.$store.state.storePhotoGiftOrderDesign.currentImagePreview.index
          ].files[
            this.$store.state.storePhotoGiftOrderDesign.currentImagePreview.index2
          ].src = image.image;

          // dodamo začetne nastavitve za filtre
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
            this.$store.state.storePhotoGiftOrderDesign.currentImagePreview.index
          ].files[
            this.$store.state.storePhotoGiftOrderDesign.currentImagePreview.index2
          ].imageSettings = this.imageSettings;*/

          let rect3;
          if (
            this.$store.state.storePhotoGiftOrderDesign.currentImagePreview
              .clipP == "rect"
          ) {
            rect3 = new fabric.Rect({
              left:
                this.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                  .left * this.itemCanvasMF[this.tab],
              top:
                this.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                  .top * this.itemCanvasMF[this.tab],
              originX: "center",
              originY: "center",
              fill: this.$store.state.storePhotoGiftOrderDesign
                .currentImagePreview.stroke,
              width:
                this.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                  .width +
                this.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                  .strokeWidth *
                  2,
              height:
                this.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                  .height +
                this.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                  .strokeWidth *
                  2,
              rx: this.$store.state.storePhotoGiftOrderDesign
                .currentImagePreview.borderRadius,
              ry: this.$store.state.storePhotoGiftOrderDesign
                .currentImagePreview.borderRadius,
            });
          } else
            rect3 = new fabric.Ellipse({
              left:
                this.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                  .left * this.itemCanvasMF[this.tab],
              top:
                this.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                  .top * this.itemCanvasMF[this.tab],
              originX: "center",
              originY: "center",
              fill: this.$store.state.storePhotoGiftOrderDesign
                .currentImagePreview.stroke,
              rx:
                this.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                  .width /
                  2 +
                this.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                  .strokeWidth,
              ry:
                this.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                  .height /
                  2 +
                this.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                  .strokeWidth,
            });

          let group3 = new fabric.Group([rect3], {
            myType: "templateImage",
            cIndex: this.tab,
            iIndex: this.$store.state.storePhotoGiftOrderDesign.iIndex,
            left:
              this.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                .left * this.itemCanvasMF[this.tab],
            top:
              this.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                .top * this.itemCanvasMF[this.tab],
            angle:
              this.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                .angle,
            lockMovementX: true,
            lockMovementY: true,
            originX: "center",
            originY: "center",
            selectable: true,
            centeredScaling: true,
            borderColor: "rgba(255,0,0,0.5)",
            cornerStrokeColor: "rgba(0,0,0,0)",
            borderScaleFactor:
              (this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                this.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                  .index
              ].selected.width /
                150) *
              this.itemCanvasMF[this.tab],
            rotatingPointOffset: 0,
            cornerSize: this.$vuetify.breakpoint.smAndUp
              ? (this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                  this.$store.state.storePhotoGiftOrderDesign
                    .currentImagePreview.index
                ].selected.width /
                  25) *
                this.itemCanvasMF[this.tab]
              : (this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                  this.$store.state.storePhotoGiftOrderDesign
                    .currentImagePreview.index
                ].selected.width /
                  12) *
                this.itemCanvasMF[this.tab],
            cornerShape: "rect",
            transparentCorners: true,
          });

          let vm = this;
          fabric.Image.fromURL(
            image.image,
            function (img) {
              if (img._element == null) {
                console.log(
                  "ERROR fabric.Image.fromURL in cropFinal() function "
                );
                vm.$store.commit({
                  type: "showSnackbar",
                  color: "error",
                  message: this.$t("userNewPhotoGiftOrderLoadingImageError"),
                });
              }
              let img3 = img.set({
                left:
                  vm.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                    .left * vm.itemCanvasMF[vm.tab],
                top:
                  vm.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                    .top * vm.itemCanvasMF[vm.tab],
                angle:
                  vm.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                    .angle,
                originX: "center",
                originY: "center",
              });

              if (
                vm.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                  .clipP == "circle"
              ) {
                img3.clipPath = new fabric.Ellipse({
                  fill: "#FF000080",
                  top: 0,
                  left: 0,
                  rx:
                    Number(
                      vm.$store.state.storePhotoGiftOrderDesign
                        .currentImagePreview.width
                    ) / 2,
                  ry:
                    Number(
                      vm.$store.state.storePhotoGiftOrderDesign
                        .currentImagePreview.height
                    ) / 2,
                  angle: Number(
                    vm.$store.state.storePhotoGiftOrderDesign
                      .currentImagePreview.angle
                  ),
                  originX: "center",
                  originY: "center",
                });
              }

              group3.setControlsVisibility({
                tl: false,
                tr: false,
                bl: false,
                br: false,
                ml: true,
                mt: true,
                mr: false,
                mb: false,
                mtr: false,
              });

              group3.customiseCornerIcons({
                ml: {
                  icon: require("@/assets/icon-plus.svg"),
                },
                mt: {
                  icon: require("@/assets/icon-plus.svg"),
                },
              });

              group3.on("deselected", function () {
                vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.showSimplePlaceholderImageControls = false;
              });

              group3.on("selected", function () {
                vm.$store.state.storePhotoGiftOrderDesign.iIndex =
                  group3.iIndex;
                vm.$store.state.storePhotoGiftOrderDesign.cIndexMode =
                  "addNewTemplateImage";

                vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.showSimplePlaceholderImageControls = true;
                console.log("SELECTED!!");
                vm.filterImageSettings = vm.imageSettings;
                vm.filterImageIndex = 1;

                fabric.Canvas.prototype.customiseControls({
                  ml: {
                    cursor: "pointer",
                    action: function () {
                      vm.$store.state.storePhotoGiftOrderDesign.cIndexMode =
                        "addNewTemplateImage";
                      document
                        .getElementById(
                          "canvas-0-input-" +
                            vm.$store.state.storePhotoGiftOrderDesign.iIndex
                        )
                        .click();
                    },
                  },
                  mt: {
                    cursor: "pointer",
                    action: function () {
                      vm.$store.state.storePhotoGiftOrderDesign.cIndexMode =
                        "addNewTemplateImage";
                      document
                        .getElementById(
                          "canvas-0-input-" +
                            vm.$store.state.storePhotoGiftOrderDesign.iIndex
                        )
                        .click();
                    },
                  },
                });
                console.log(
                  vm.$store.state.storePhotoGiftOrderDesign.cIndexMode,
                  vm.$store.state.storePhotoGiftOrderDesign.iIndex
                );
              });

              group3.addWithUpdate(img3);
              group3.scaleX = 1 * vm.itemCanvasMF[vm.tab];
              group3.scaleY = 1 * vm.itemCanvasMF[vm.tab];

              // novo template sliko dodamo pod ostale slike
              let c = 0;
              vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.forEachObject(
                (x) => {
                  if (
                    x.myType != "middleImage" &&
                    x.myType != "frame" &&
                    x.myType != "templateFrame" &&
                    x.myType != "templateFramePlaceholder" &&
                    x.myType != "collageGroup" &&
                    x.myType != "simpleImage" &&
                    x.myType != "sticker" &&
                    x.myType != "text" &&
                    x.myType != "freeDrawing"
                  )
                    c++;
                }
              );
              vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas
                .insertAt(group3, c <= 0 ? 0 : c - 1)
                .requestRenderAll();

              vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                vm.$store.state.storePhotoGiftOrderDesign.currentImagePreview.index
              ].selected.items[
                vm.$store.state.storePhotoGiftOrderDesign.currentImagePreview.index2
              ].ready = true;

              /*vm.canvasTemplates[
                vm.$store.state.storePhotoGiftOrderDesign.currentImagePreview.index
              ].canvas.forEachObject((x) => {
                console.log(x.myType);
              });*/

              /*console.log(
                vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                  vm.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                    .index
                ]
              );*/
            },
            { crossOrigin: "*" }
          );
        } else if (
          this.$store.state.storePhotoGiftOrderDesign.cIndexMode ==
          "addNewFrameTemplateImage"
        ) {
          console.log(
            "USER NEW FRAME TEMPLATE IMAGE",
            this.$store.state.storePhotoGiftOrderDesign.iIndex,
            this.$store.state.storePhotoGiftOrderDesign.currentImagePreview
          );

          // izbrišemo vse objekte z istima indeksoma
          let rectanglegroups =
            this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas._objects.filter(
              (obj) =>
                obj.iIndex ==
                  this.$store.state.storePhotoGiftOrderDesign.iIndex &&
                (obj.myType == "templateFramePlaceholder" ||
                  obj.myType == "templateFrame")
            );

          rectanglegroups.map((obj) => {
            try {
              this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.remove(
                obj
              );
            } catch (error) {
              console.log(error);
            }
          });

          /*// izrez predefinirane template slike
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
            this.$store.state.storePhotoGiftOrderDesign.currentImagePreview.index
          ].filesFrames[
            this.$store.state.storePhotoGiftOrderDesign.currentImagePreview.index2
          ].src = image.image;

          // dodamo začetne nastavitve za filtre
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
            this.$store.state.storePhotoGiftOrderDesign.currentImagePreview.index
          ].filesFrames[
            this.$store.state.storePhotoGiftOrderDesign.currentImagePreview.index2
          ].imageSettings = this.imageSettings;*/

          let vm2 = this;
          fabric.Image.fromURL(
            this.$store.state.storePhotoGiftOrderDesign.currentImagePreview
              .imageFrame,
            function (img) {
              if (img._element == null) {
                console.log(
                  "ERROR fabric.Image.fromURL in cropFinal() function "
                );
                vm.$store.commit({
                  type: "showSnackbar",
                  color: "error",
                  message: this.$t("userNewPhotoGiftOrderLoadingImageError"),
                });
              }
              let img1 = img.set({
                width:
                  vm2.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                    .fWidth,
                height:
                  vm2.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                    .fHeight,
                selectable: false,
                evented: false,
                opacity: 1,
              });

              let vm = vm2;
              fabric.Image.fromURL(
                image.image,
                function (img) {
                  if (img._element == null) {
                    console.log(
                      "ERROR fabric.Image.fromURL in cropFinal() function "
                    );
                    vm.$store.commit({
                      type: "showSnackbar",
                      color: "error",
                      message: this.$t(
                        "userNewPhotoGiftOrderLoadingImageError"
                      ),
                    });
                  }
                  let img3 = img.set({
                    left: vm.$store.state.storePhotoGiftOrderDesign
                      .currentImagePreview.coordinates.left,
                    top: vm.$store.state.storePhotoGiftOrderDesign
                      .currentImagePreview.coordinates.top,
                    angle: vm.$store.state.storePhotoGiftOrderDesign
                      .currentImagePreview.rotated
                      ? vm.$store.state.storePhotoGiftOrderDesign
                          .currentImagePreview.coordinates.angle + 90
                      : vm.$store.state.storePhotoGiftOrderDesign
                          .currentImagePreview.coordinates.angle,
                    originX: "center",
                    originY: "center",
                    clipP:
                      vm.$store.state.storePhotoGiftOrderDesign
                        .currentImagePreview.coordinates.mode,
                    lockMovementX: true,
                    lockMovementY: true,
                    selectable: false,
                  });

                  let group1 = new fabric.Group([img3, img1], {
                    myType: "templateFrame",
                    cIndex: vm.activeTab,
                    iIndex: vm.$store.state.storePhotoGiftOrderDesign.iIndex,
                    left:
                      vm.$store.state.storePhotoGiftOrderDesign
                        .currentImagePreview.left *
                      vm.itemCanvasMF[vm.activeTab],
                    top:
                      vm.$store.state.storePhotoGiftOrderDesign
                        .currentImagePreview.top *
                      vm.itemCanvasMF[vm.activeTab],
                    angle:
                      vm.$store.state.storePhotoGiftOrderDesign
                        .currentImagePreview.angle,
                    scaleX:
                      vm.$store.state.storePhotoGiftOrderDesign
                        .currentImagePreview.scaleX *
                      vm.itemCanvasMF[vm.activeTab],
                    scaleY:
                      vm.$store.state.storePhotoGiftOrderDesign
                        .currentImagePreview.scaleY *
                      vm.itemCanvasMF[vm.activeTab],
                    lockMovementX: true,
                    lockMovementY: true,
                    originX: "center",
                    originY: "center",
                    selectable: true,
                    centeredScaling: true,
                    borderColor: "rgba(255,0,0,0.5)",
                    cornerStrokeColor: "rgba(0,0,0,0)",
                    borderScaleFactor:
                      (vm.$store.state.storePhotoGiftOrderDesign
                        .canvasTemplates[
                        vm.$store.state.storePhotoGiftOrderDesign
                          .currentImagePreview.index
                      ].selected.width /
                        150) *
                      vm.itemCanvasMF[vm.activeTab],
                    rotatingPointOffset: 0,
                    cornerSize: vm.$vuetify.breakpoint.smAndUp
                      ? (vm.$store.state.storePhotoGiftOrderDesign
                          .canvasTemplates[
                          vm.$store.state.storePhotoGiftOrderDesign
                            .currentImagePreview.index
                        ].selected.width /
                          25) *
                        vm.itemCanvasMF[vm.activeTab]
                      : (vm.$store.state.storePhotoGiftOrderDesign
                          .canvasTemplates[
                          vm.$store.state.storePhotoGiftOrderDesign
                            .currentImagePreview.index
                        ].selected.width /
                          12) *
                        vm.itemCanvasMF[vm.activeTab],
                    cornerShape: "rect",
                    transparentCorners: true,
                  });

                  group1.setControlsVisibility({
                    tl: false,
                    tr: false,
                    bl: false,
                    br: false,
                    ml: true,
                    mt: true,
                    mr: false,
                    mb: false,
                    mtr: false,
                  });

                  group1.customiseCornerIcons({
                    ml: {
                      icon: require("@/assets/icon-plus.svg"),
                    },
                    mt: {
                      icon: require("@/assets/icon-plus.svg"),
                    },
                  });

                  group1.on("deselected", function () {
                    vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.showSimplePlaceholderImageControls = false;
                  });

                  group1.on("selected", function () {
                    vm.$store.state.storePhotoGiftOrderDesign.iIndex =
                      group1.iIndex;
                    vm.$store.state.storePhotoGiftOrderDesign.cIndexMode =
                      "addNewFrameTemplateImage";

                    vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.showSimplePlaceholderImageControls = true;
                    console.log("SELECTED!!");
                    vm.filterImageSettings = vm.imageSettings;
                    vm.filterImageIndex = 0;

                    fabric.Canvas.prototype.customiseControls({
                      ml: {
                        cursor: "pointer",
                        action: function () {
                          document
                            .getElementById(
                              "canvas-0-input-frame-" +
                                vm.$store.state.storePhotoGiftOrderDesign.iIndex
                            )
                            .click();
                        },
                      },
                      mt: {
                        cursor: "pointer",
                        action: function () {
                          document
                            .getElementById(
                              "canvas-0-input-frame-" +
                                vm.$store.state.storePhotoGiftOrderDesign.iIndex
                            )
                            .click();
                        },
                      },
                    });
                    console.log(
                      vm.$store.state.storePhotoGiftOrderDesign.cIndexMode,
                      vm.$store.state.storePhotoGiftOrderDesign.iIndex
                    );
                  });

                  if (
                    vm.$store.state.storePhotoGiftOrderDesign
                      .currentImagePreview.clipP == "circle"
                  ) {
                    img3.clipPath = new fabric.Ellipse({
                      top:
                        -Number(
                          vm.$store.state.storePhotoGiftOrderDesign
                            .currentImagePreview.coordinates.height
                        ) / 2,
                      left:
                        -Number(
                          vm.$store.state.storePhotoGiftOrderDesign
                            .currentImagePreview.coordinates.width
                        ) / 2,
                      rx:
                        Number(
                          vm.$store.state.storePhotoGiftOrderDesign
                            .currentImagePreview.coordinates.width
                        ) / 2,
                      ry:
                        Number(
                          vm.$store.state.storePhotoGiftOrderDesign
                            .currentImagePreview.coordinates.height
                        ) / 2,
                    });
                  }

                  // novo template sliko dodamo pod ostale slike
                  let c = 0;
                  vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.forEachObject(
                    (x) => {
                      if (
                        x.myType != "collageGroup" &&
                        x.myType != "simpleImage" &&
                        x.myType != "sticker" &&
                        x.myType != "text" &&
                        x.myType != "freeDrawing"
                      )
                        c++;
                    }
                  );

                  vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                    vm.$store.state.storePhotoGiftOrderDesign
                      .currentImagePreview.index
                  ].canvas
                    .insertAt(group1, c <= 0 ? 0 : c - 1)
                    .requestRenderAll();
                },
                { crossOrigin: "*" }
              );
            },
            { crossOrigin: "*" }
          );
        }
      } else {
        if (
          this.$store.state.storePhotoGiftOrderDesign.cIndexMode ==
          "addNewExtraImage"
        ) {
          // izrez custom addimage slike
          //let getImageData = this.$refs.cropper.getImageData();

          //let getCanvasData = this.$refs.cropper.getCanvasData();
          //let getCropBoxData = this.$refs.cropper.getCropBoxData();
          //console.log(getImageData);
          //console.log(getCanvasData);
          //console.log(getCropBoxData);

          this.singleImageFile = image.image;

          //const iWidth = getImageData.naturalWidth;
          //const iHeight = getImageData.naturalHeight;
          //console.log(iWidth, iHeight);

          /*let vm = this;
          let frame = new fabric.Image.fromURL(
            this.currentImagePreview.frame,
            function(img) {
              if (img._element == null) {
                console.log(
                  "ERROR fabric.Image.fromURL in cropFinal() function "
                );
                vm.$store.commit({
                  type: "showSnackbar",
                  color: "error",
                  message: this.$t("userNewPhotoGiftOrderLoadingImageError"),
                });
              }
              img.scaleToWidth(vm.currentImagePreview.width);
              img.scaleToHeight(vm.currentImagePreview.height);
            },
            {
              // Needed to position backgroundImage at 0/0
              originX: "left",
              originY: "top",
              crossOrigin: "anonymous"
            }
          );*/

          let vm = this;
          fabric.Image.fromURL(
            this.$store.state.storePhotoGiftOrderDesign.currentImagePreview.item
              .image,
            function (img) {
              if (img._element == null) {
                console.log(
                  "ERROR fabric.Image.fromURL in cropFinal() function "
                );
                vm.$store.commit({
                  type: "showSnackbar",
                  color: "error",
                  message: this.$t("userNewPhotoGiftOrderLoadingImageError"),
                });
              }
              let img1 = img.set({
                width:
                  vm.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                    .item.width,
                height:
                  vm.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                    .item.height,
              });

              let vm2 = vm;
              fabric.Image.fromURL(
                vm.singleImageFile,
                function (img) {
                  if (img._element == null) {
                    console.log(
                      "ERROR fabric.Image.fromURL in cropFinal() function "
                    );
                    vm2.$store.commit({
                      type: "showSnackbar",
                      color: "error",
                      message: this.$t(
                        "userNewPhotoGiftOrderLoadingImageError"
                      ),
                    });
                  }
                  let img2 = img.set({
                    left: vm2.$store.state.storePhotoGiftOrderDesign
                      .currentImagePreview.coordinates.left,
                    top: vm2.$store.state.storePhotoGiftOrderDesign
                      .currentImagePreview.coordinates.top,
                    width:
                      vm2.$store.state.storePhotoGiftOrderDesign
                        .currentImagePreview.coordinates.width,
                    height:
                      vm2.$store.state.storePhotoGiftOrderDesign
                        .currentImagePreview.coordinates.height,
                    angle:
                      vm2.$store.state.storePhotoGiftOrderDesign
                        .currentImagePreview.coordinates.angle,
                    originX: "center",
                    originY: "center",
                  });

                  if (
                    vm2.$store.state.storePhotoGiftOrderDesign
                      .currentImagePreview.coordinates.mode == "circle"
                  ) {
                    img2.set({
                      clipPath: new fabric.Ellipse({
                        fill: "#FF000080",
                        top: 0,
                        left: 0,
                        rx:
                          Number(
                            vm2.$store.state.storePhotoGiftOrderDesign
                              .currentImagePreview.coordinates.width
                          ) / 2,
                        ry:
                          Number(
                            vm2.$store.state.storePhotoGiftOrderDesign
                              .currentImagePreview.coordinates.height
                          ) / 2,
                        angle: Number(
                          vm2.$store.state.storePhotoGiftOrderDesign
                            .currentImagePreview.coordinates.angle
                        ),
                        originX: "center",
                        originY: "center",
                      }),
                    });
                  }
                  let group1 = new fabric.Group([img2, img1], {
                    myType: "frame",
                    left:
                      (vm2.$store.state.storePhotoGiftOrderDesign
                        .canvasTemplates[
                        vm2.$store.state.storePhotoGiftOrderDesign
                          .currentImagePreview.index
                      ].selected.width /
                        2) *
                      vm2.itemCanvasMF[
                        vm2.$store.state.storePhotoGiftOrderDesign
                          .currentImagePreview.index
                      ],
                    top:
                      (vm2.$store.state.storePhotoGiftOrderDesign
                        .canvasTemplates[
                        vm2.$store.state.storePhotoGiftOrderDesign
                          .currentImagePreview.index
                      ].selected.height /
                        2) *
                      vm2.itemCanvasMF[
                        vm2.$store.state.storePhotoGiftOrderDesign
                          .currentImagePreview.index
                      ],
                    angle: 0,
                    scaleX:
                      1 *
                      vm2.itemCanvasMF[
                        vm2.$store.state.storePhotoGiftOrderDesign
                          .currentImagePreview.index
                      ],
                    scaleY:
                      1 *
                      vm2.itemCanvasMF[
                        vm2.$store.state.storePhotoGiftOrderDesign
                          .currentImagePreview.index
                      ],
                    originX: "center",
                    originY: "center",
                    selectable: true,
                    centeredScaling: true,
                    borderColor: "rgba(255,0,0,0.5)",
                    cornerStrokeColor: "rgba(0,0,0,0)",
                    borderScaleFactor:
                      (vm2.$store.state.storePhotoGiftOrderDesign
                        .canvasTemplates[
                        vm2.$store.state.storePhotoGiftOrderDesign
                          .currentImagePreview.index
                      ].selected.width /
                        150) *
                      vm2.itemCanvasMF[
                        vm2.$store.state.storePhotoGiftOrderDesign
                          .currentImagePreview.index
                      ],
                    rotatingPointOffset:
                      (vm2.$store.state.storePhotoGiftOrderDesign
                        .canvasTemplates[
                        vm2.$store.state.storePhotoGiftOrderDesign
                          .currentImagePreview.index
                      ].selected.width /
                        20) *
                      vm2.itemCanvasMF[
                        vm2.$store.state.storePhotoGiftOrderDesign
                          .currentImagePreview.index
                      ],
                    cornerSize: vm2.$vuetify.breakpoint.smAndUp
                      ? (vm2.$store.state.storePhotoGiftOrderDesign
                          .canvasTemplates[
                          vm2.$store.state.storePhotoGiftOrderDesign
                            .currentImagePreview.index
                        ].selected.width /
                          25) *
                        vm2.itemCanvasMF[
                          vm2.$store.state.storePhotoGiftOrderDesign
                            .currentImagePreview.index
                        ]
                      : (vm2.$store.state.storePhotoGiftOrderDesign
                          .canvasTemplates[
                          vm2.$store.state.storePhotoGiftOrderDesign
                            .currentImagePreview.index
                        ].selected.width /
                          12) *
                        vm2.itemCanvasMF[
                          vm2.$store.state.storePhotoGiftOrderDesign
                            .currentImagePreview.index
                        ],
                    cornerShape: "rect",
                    transparentCorners: true,
                  });

                  // zmanjšamo velikost prevelikim okvirjem
                  let dW =
                    ((vm2.$store.state.storePhotoGiftOrderDesign
                      .canvasTemplates[
                      vm2.$store.state.storePhotoGiftOrderDesign
                        .currentImagePreview.index
                    ].selected.width *
                      vm2.itemCanvasMF[
                        vm2.$store.state.storePhotoGiftOrderDesign
                          .currentImagePreview.index
                      ] -
                      group1.getScaledWidth()) *
                      100) /
                    vm2.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                      vm2.$store.state.storePhotoGiftOrderDesign
                        .currentImagePreview.index
                    ].selected.width;
                  let dH =
                    ((vm2.$store.state.storePhotoGiftOrderDesign
                      .canvasTemplates[
                      vm2.$store.state.storePhotoGiftOrderDesign
                        .currentImagePreview.index
                    ].selected.height *
                      vm2.itemCanvasMF[
                        vm2.$store.state.storePhotoGiftOrderDesign
                          .currentImagePreview.index
                      ] -
                      group1.getScaledHeight()) *
                      100) /
                    vm2.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                      vm2.$store.state.storePhotoGiftOrderDesign
                        .currentImagePreview.index
                    ].selected.height;
                  let aRatio =
                    group1.getScaledWidth() / group1.getScaledHeight();
                  let tW =
                    vm2.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                      vm2.$store.state.storePhotoGiftOrderDesign
                        .currentImagePreview.index
                    ].selected.width *
                    vm2.itemCanvasMF[
                      vm2.$store.state.storePhotoGiftOrderDesign
                        .currentImagePreview.index
                    ] *
                    0.7;
                  let tH =
                    vm2.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                      vm2.$store.state.storePhotoGiftOrderDesign
                        .currentImagePreview.index
                    ].selected.height *
                    vm2.itemCanvasMF[
                      vm2.$store.state.storePhotoGiftOrderDesign
                        .currentImagePreview.index
                    ] *
                    0.7;

                  /*console.log("dW / dH", dW, dH);
                  console.log("aRatio", aRatio);
                  console.log("tW / tH", tW, tH);*/

                  if (dW < 0 || dH < 0) {
                    if (dW < dH) {
                      group1.scaleToWidth(tW);
                      group1.scaleToHeight(tW * aRatio);
                    } else {
                      group1.scaleToHeight(tH);
                      group1.scaleToWidth(tH * aRatio);
                    }
                  }

                  group1.setControlsVisibility({
                    tl: true,
                    tr: true,
                    bl: true,
                    br: true,
                    ml: true,
                    mt: false,
                    mr: true,
                    mb: false,
                    mtr: true,
                  });

                  group1.customiseCornerIcons({
                    tl: {
                      icon: require("@/assets/resize-icon-tl.svg"),
                    },
                    tr: {
                      icon: require("@/assets/resize-icon-tr.svg"),
                    },
                    bl: {
                      icon: require("@/assets/delete-icon.svg"),
                    },
                    br: {
                      icon: require("@/assets/resize-icon-br.svg"),
                    },
                    ml: {
                      icon: require("@/assets/down-arrow.svg"),
                    },
                    mr: {
                      icon: require("@/assets/up-arrow.svg"),
                    },
                    mtr: {
                      icon: require("@/assets/rotate-icon.svg"),
                    },
                  });

                  group1.on("deselected", function () {
                    vm2.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.showSimplePlaceholderImageControls = false;
                    //console.log("deselected => exitImageEditing/hideControls");
                  });

                  group1.on("selected", function () {
                    vm2.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.showSimplePlaceholderImageControls = true;
                    console.log("SELECTED!!");
                    vm2.filterImageSettings = vm2.cImageSettings;
                    vm2.filterImageIndex = 0;

                    fabric.Canvas.prototype.customiseControls({
                      bl: {
                        action: "remove",
                        cursor: "pointer",
                      },
                      br: {
                        cursor: "resize",
                        action: "scale",
                      },
                      ml: {
                        cursor: "pointer",
                        action: function (e, target) {
                          target.sendBackwards(true);
                        },
                      },
                      mr: {
                        cursor: "pointer",
                        action: function (e, target) {
                          target.bringForward(true);
                        },
                      },
                    });
                  });

                  // novo template sliko dodamo pod ostale slike
                  let c = 0;
                  vm2.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.forEachObject(
                    (x) => {
                      if (
                        x.myType != "collageGroup" &&
                        x.myType != "simpleImage" &&
                        x.myType != "sticker" &&
                        x.myType != "text" &&
                        x.myType != "freeDrawing"
                      )
                        c++;
                    }
                  );

                  /*group1.scale(
                    1 / vm2.itemCanvasMF[vm2.currentImagePreview.index]
                  );*/

                  vm2.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas
                    .insertAt(group1, c)
                    .requestRenderAll();
                  console.log("New extra image added.");
                },
                { crossOrigin: "anonymous" }
              );
            },
            { crossOrigin: "anonymous" }
          );
        } else if (
          this.$store.state.storePhotoGiftOrderDesign.cIndexMode ==
          "addNewImageBackground"
        ) {
          // render new background image
          this.dialogWait = true;
          this.dialogWaitMsg = this.$t(
            "userNewPhotoGiftOrderLoadingBackgroundImage"
          );

          this.singleImageFile = image.image;

          let vm = this;
          fabric.Image.fromURL(
            this.singleImageFile,
            function (img) {
              if (img._element == null) {
                vm.dialogWait = false;
                console.log(
                  "ERROR fabric.Image.fromURL in cropFinal() function "
                );
                vm.$store.commit({
                  type: "showSnackbar",
                  color: "error",
                  message: this.$t("userNewPhotoGiftOrderLoadingImageError"),
                });
              }
              img.scaleToWidth(
                vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                  vm.activeTab
                ].selected.width * vm.itemCanvasMF[vm.activeTab]
              );
              img.scaleToHeight(
                vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                  vm.activeTab
                ].selected.height * vm.itemCanvasMF[vm.activeTab]
              );

              vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.setBackgroundImage(
                img,
                vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.requestRenderAll.bind(
                  vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
                    .canvas
                ),
                { crossOrigin: "*" }
              );

              vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.showBackgroundImageControls = true; // prikaz gumbov za upravljanje ozadja
              vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.backgroundImageBrightness = 0; // reset svetlosti ozadja
              vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.backgroundImageContrast = 0; // reset svetlosti ozadja
              vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.backgroundImageBlur = 0; // reset blur ozadja
              vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.backgroundImageFilter = 0; // reset filtra ozadja
              vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.transparentBack = false;
              vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.backgroundColor =
                "#00000000";
              vm.dialogWait = false;

              console.log("USER ADDED NEW BACKGROUND IMAGE");
            },
            {
              // Needed to position backgroundImage at 0/0
              originX: "left",
              originY: "top",
              crossOrigin: "anonymous",
            }
          );
        } else if (
          this.$store.state.storePhotoGiftOrderDesign.cIndexMode ==
            "addNewSimpleSquareImage" ||
          this.$store.state.storePhotoGiftOrderDesign.cIndexMode ==
            "addNewSimpleCircleImage"
        ) {
          this.dialogWait = true;
          this.dialogWaitMsg = this.$t(
            "userNewPhotoGiftOrderLoadingSimpleTemplateImage"
          );

          this.singleImageFile = image;

          let rect3;
          if (
            this.$store.state.storePhotoGiftOrderDesign.cIndexMode ==
            "addNewSimpleSquareImage"
          ) {
            rect3 = new fabric.Rect({
              originX: "center",
              originY: "center",
              fill: this.$store.state.storePhotoGiftOrderDesign
                .currentImagePreview.stroke,
              width:
                this.singleImageFile.width +
                this.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                  .strokeWidth *
                  2,
              height:
                this.singleImageFile.height +
                this.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                  .strokeWidth *
                  2,
              left:
                (this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                  this.tab
                ].selected.width /
                  2) *
                this.itemCanvasMF[this.tab],
              top:
                (this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                  this.tab
                ].selected.height /
                  2) *
                this.itemCanvasMF[this.tab],
              rx: this.$store.state.storePhotoGiftOrderDesign
                .currentImagePreview.borderRadius,
              ry: this.$store.state.storePhotoGiftOrderDesign
                .currentImagePreview.borderRadius,
            });
          } else
            rect3 = new fabric.Ellipse({
              left:
                (this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                  this.tab
                ].selected.width /
                  2) *
                this.itemCanvasMF[this.tab],
              top:
                (this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                  this.tab
                ].selected.height /
                  2) *
                this.itemCanvasMF[this.tab],
              originX: "center",
              originY: "center",
              width: this.singleImageFile.width,
              height: this.singleImageFile.height,
              fill: this.$store.state.storePhotoGiftOrderDesign
                .currentImagePreview.stroke,
              rx:
                this.singleImageFile.width / 2 +
                this.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                  .strokeWidth,
              ry:
                this.singleImageFile.height / 2 +
                this.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                  .strokeWidth,
            });

          let group3 = new fabric.Group([rect3], {
            myType: "simpleImage",
            cIndex: this.tab,
            cIndexMode: this.$store.state.storePhotoGiftOrderDesign.cIndexMode,
            iIndex: this.$store.state.storePhotoGiftOrderDesign.iIndex,
            angle: 0,
            originX: "center",
            originY: "center",
            selectable: true,
            centeredScaling: true,
            borderColor: "rgba(255,0,0,0.5)",
            cornerStrokeColor: "rgba(0,0,0,0)",
            borderScaleFactor:
              (this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                this.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                  .index
              ].selected.width /
                150) *
              this.itemCanvasMF[this.tab],
            rotatingPointOffset: 0,
            cornerSize: this.$vuetify.breakpoint.smAndUp
              ? (this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                  this.$store.state.storePhotoGiftOrderDesign
                    .currentImagePreview.index
                ].selected.width /
                  25) *
                this.itemCanvasMF[this.tab]
              : (this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                  this.$store.state.storePhotoGiftOrderDesign
                    .currentImagePreview.index
                ].selected.width /
                  12) *
                this.itemCanvasMF[this.tab],
            cornerShape: "rect",
            transparentCorners: true,
          });

          let vm = this;
          fabric.Image.fromURL(
            this.singleImageFile.image,
            function (img) {
              if (img._element == null) {
                console.log(
                  "ERROR fabric.Image.fromURL in cropFinal() function "
                );
                vm.$store.commit({
                  type: "showSnackbar",
                  color: "error",
                  message: this.$t("userNewPhotoGiftOrderLoadingImageError"),
                });
              }
              let img3 = img.set({
                left:
                  (vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                    vm.tab
                  ].selected.width /
                    2) *
                  vm.itemCanvasMF[vm.tab],
                top:
                  (vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                    vm.tab
                  ].selected.height /
                    2) *
                  vm.itemCanvasMF[vm.tab],
                angle: 0,
                originX: "center",
                originY: "center",
              });

              if (
                vm.$store.state.storePhotoGiftOrderDesign.cIndexMode ==
                "addNewSimpleCircleImage"
              ) {
                img3.clipPath = new fabric.Ellipse({
                  fill: "#FF000080",
                  top: 0,
                  left: 0,
                  rx: vm.singleImageFile.width / 2,
                  ry: vm.singleImageFile.height / 2,
                  angle: 0,
                  originX: "center",
                  originY: "center",
                });
              }

              group3.setControlsVisibility({
                tl: true,
                tr: true,
                bl: true,
                br: true,
                ml: true,
                mt: false,
                mr: true,
                mb: false,
                mtr: true,
              });

              group3.customiseCornerIcons({
                tl: {
                  icon: require("@/assets/resize-icon-tl.svg"),
                },
                tr: {
                  icon: require("@/assets/resize-icon-tr.svg"),
                },
                bl: {
                  icon: require("@/assets/delete-icon.svg"),
                },
                br: {
                  icon: require("@/assets/resize-icon-br.svg"),
                },
                ml: {
                  icon: require("@/assets/down-arrow.svg"),
                },
                mr: {
                  icon: require("@/assets/up-arrow.svg"),
                },
                mtr: {
                  icon: require("@/assets/rotate-icon.svg"),
                },
              });

              group3.on("deselected", function () {
                vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.showSimplePlaceholderImageControls = false;
                vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.showSimpleFrameRect = false;
              });

              group3.on("selected", function () {
                vm.$store.state.storePhotoGiftOrderDesign.iIndex =
                  group3.iIndex;
                vm.$store.state.storePhotoGiftOrderDesign.cIndexMode =
                  group3.cIndexMode;

                vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.showSimplePlaceholderImageControls = true;
                vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.showSimpleFrameRect = true;
                console.log("SELECTED!!");
                vm.filterImageSettings = vm.cImageSettings;
                vm.filterImageIndex = 1;

                fabric.Canvas.prototype.customiseControls({
                  bl: {
                    action: "remove",
                    cursor: "pointer",
                  },
                  ml: {
                    cursor: "pointer",
                    action: function (e, target) {
                      target.sendBackwards(true);
                    },
                  },
                  mr: {
                    cursor: "pointer",
                    action: function (e, target) {
                      target.bringForward(true);
                    },
                  },
                });
              });

              group3.addWithUpdate(img3);

              // poskrbimo za pomanjšanje slike, če je prevelika
              let wWidth = 1;
              let wHeight = 1;
              let wReal = 1;
              let wFactor = 1;

              if (
                group3.width >
                  vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
                    .canvas.width ||
                group3.height >
                  vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
                    .canvas.height
              ) {
                wWidth =
                  (group3.width * 100) /
                  vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
                    .canvas.width;
                wHeight =
                  (group3.height * 100) /
                  vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
                    .canvas.height;

                wReal = wWidth >= wHeight ? wWidth : wHeight;

                if (wReal > 90 && wReal < 180) {
                  wFactor = 0.5;
                } else if (wReal >= 180 && wReal < 270) {
                  wFactor = 0.37;
                } else if (wReal >= 270 && wReal < 390) {
                  wFactor = 0.25;
                } else if (wReal >= 390) {
                  wFactor = 0.13;
                }

                console.log(wWidth, wHeight, wReal, wFactor);
              }

              group3.scaleX = 1 * vm.itemCanvasMF[vm.tab] * Math.abs(wFactor);
              group3.scaleY = 1 * vm.itemCanvasMF[vm.tab] * Math.abs(wFactor);

              console.log(group3.scaleX, group3.scaleY);

              // novo template sliko dodamo pod ostale slike
              let c = 0;
              vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.forEachObject(
                (x) => {
                  if (
                    x.myType != "collageGroup" &&
                    x.myType != "simpleImage" &&
                    x.myType != "sticker" &&
                    x.myType != "text" &&
                    x.myType != "freeDrawing"
                  )
                    c++;
                }
              );

              vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas
                .insertAt(group3, c)
                .requestRenderAll();

              vm.dialogWait = false;
            },
            { crossOrigin: "*" }
          );
          console.log("NEW SIMPLE SQUARE IMAGE ADDED.");
        }
      }
      this.showCropper = false;
    },
    handlerAddColorPicker() {
      this.dialogColorPickerActive = true;
    },
    handlerRemoveBackground(index) {
      if (
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[index]
          .selected.allowTransparentBack
      ) {
        let vm = this;
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.setBackgroundColor(
          {
            source: require("@/assets/transparent-back.png"),
            repeat: "repeat",
          },
          function () {
            vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.backgroundImage = 0;
            vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.transparentBack = true;
            vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.requestRenderAll();
          }
        );
      } else {
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.backgroundColor =
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
            index
          ].selected.transparentBackColor;
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.backgroundImage = 0;
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.transparentBack = false;
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.requestRenderAll();
      }
      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.showBackgroundImageControls = false; // skrijemo gumbe za upravljanje ozadja
    },
    dialogColorPickerBackgroundColorApply() {
      if (this.dialogColorPickerGradient) {
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.backgroundColor =
          this.dialogColorPickerColor;
        let transpose =
          "#" +
          lightenDarkenColor(this.dialogColorPickerColor.substring(1, 7), -40) +
          "FF";
        if (transpose.length <= 7)
          transpose = "#00" + transpose.substring(1, 7);
        console.log("transpose", transpose);
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.setBackgroundColor(
          new fabric.Gradient({
            type: "radial",
            coords: {
              r1: 360,
              r2:
                this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                  this.activeTab
                ].selected.width * this.itemCanvasMF[this.activeTab],
              x1:
                this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                  this.activeTab
                ].selected.width * this.itemCanvasMF[this.activeTab],
              y1:
                this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                  this.activeTab
                ].selected.height * this.itemCanvasMF[this.activeTab],
              x2:
                this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                  this.activeTab
                ].selected.width * this.itemCanvasMF[this.activeTab],
              y2:
                this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                  this.activeTab
                ].selected.height * this.itemCanvasMF[this.activeTab],
            },
            colorStops: [
              {
                color:
                  "rgba(" +
                  parseInt(this.dialogColorPickerColor.substring(1, 3), 16) +
                  ", " +
                  parseInt(this.dialogColorPickerColor.substring(3, 5), 16) +
                  ", " +
                  parseInt(this.dialogColorPickerColor.substring(5, 7), 16) +
                  ", " +
                  Math.trunc(
                    (parseInt(this.dialogColorPickerColor.substring(7, 9), 16) *
                      100) /
                      255
                  ) /
                    100 +
                  ")",
                offset: 0,
              },
              {
                color:
                  "rgba(" +
                  parseInt(transpose.substring(1, 3), 16) +
                  ", " +
                  parseInt(transpose.substring(3, 5), 16) +
                  ", " +
                  parseInt(transpose.substring(5, 7), 16) +
                  ", " +
                  Math.trunc(
                    (parseInt(transpose.substring(7, 9), 16) * 100) / 255
                  ) /
                    100 +
                  ")",
                offset: 1,
              },
            ],
          })
        );
      } else
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.backgroundColor =
          this.dialogColorPickerColor;

      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.transparentBack = false;
      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.backgroundImage = 0;
      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.showBackgroundImageControls = false; // skrijemo gumbe za upravljanje ozadja
      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.requestRenderAll();
    },
    async setBackgroundLayerSetter() {
      this.dialogWait = true;
      this.loadTemplateWithError = 0;

      this.dialogWaitMsg = this.$t(
        "userNewPhotoGiftOrderLoadingBackgroundImage"
      );
      await helper.setBackgroundLayer(
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates,
        this.activeTab,
        this.itemCanvasMF[this.activeTab]
      );

      this.dialogWait = false;

      if (this.loadTemplateWithError > 0) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: this.$t("userNewPhotoGiftOrderLoadingImageError"),
        });
      }
    },
    handlerAddNewImage(imageMode) {
      this.$store.state.storePhotoGiftOrderDesign.cIndexMode = imageMode;
      if (imageMode == "addNewImageBackground") {
        document.getElementById("addNewImageBackgroundFileInput").click();
      } else {
        document.getElementById("addNewImageFileInput").click();
      }
    },
    addNewImage(e) {
      /*if (this.$store.state.storeClient.client.basicSettings.name == "demo")
        alert(e.target.files[0].name);*/

      // reset file input fielda, da lahko izeremo 2x enako sliko
      this.uploadReady = false;
      this.$nextTick(() => {
        this.uploadReady = true;
      });

      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
        this.activeTab
      ].mainFile = e.target.files[0]; // shranimo original file, ki ga bomo dodali v paket zraven

      this.showImageDatabaseLiveSelection = false;
      readNewSimpleExtraFile(e.target.files[0]).then((img) => {
        this.cViewMode = 1;
        if (
          this.$store.state.storePhotoGiftOrderDesign.cIndexMode ==
          "addNewExtraImage"
        ) {
          if (
            img.image.attr.orientation ==
              this.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                .item.orientation ||
            !this.$store.state.storePhotoGiftOrderDesign.currentImagePreview
              .item.rotate
          ) {
            Object.assign(
              this.$store.state.storePhotoGiftOrderDesign.currentImagePreview,
              {
                image: img.image.path,
                index: this.activeTab,
                aspectRatio:
                  this.$store.state.storePhotoGiftOrderDesign
                    .currentImagePreview.coordAspectRatio,
                width:
                  this.$store.state.storePhotoGiftOrderDesign
                    .currentImagePreview.coordinates.width,
                height:
                  this.$store.state.storePhotoGiftOrderDesign
                    .currentImagePreview.coordinates.width,
              }
            );
            console.log(
              "NO ROTATE",
              this.$store.state.storePhotoGiftOrderDesign.currentImagePreview
            );
            this.showCropper = true;
          } else {
            let vm = this;
            readAndRotateUrlFile(
              this.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                .item,
              true
            ).then((img2) => {
              let tItem =
                vm.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                  .item;
              Object.assign(tItem, {
                aRatio:
                  vm.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                    .item.height /
                  vm.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                    .item.width,
                width:
                  vm.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                    .item.height,
                height:
                  vm.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                    .item.width,
                image: img2.path,
              });

              Object.assign(
                vm.$store.state.storePhotoGiftOrderDesign.currentImagePreview,
                {
                  image: img.image.path,
                  index: vm.activeTab,
                  aspectRatio: tItem.aRatio,
                  width: tItem.width,
                  height: tItem.height,
                  scaleX: 1,
                  scaleY: 1,
                  item: tItem,
                  coordAspectRatio:
                    tItem.coordinates.height / tItem.coordinates.width,
                  coordinates: {
                    angle: tItem.coordinates.angle,
                    top: img2.attr.y,
                    left: img2.attr.x,
                    height: tItem.coordinates.width,
                    width: tItem.coordinates.height,
                  },
                }
              );
              console.log(
                "ROTATE",
                vm.$store.state.storePhotoGiftOrderDesign.currentImagePreview
              );
              vm.showCropper = true;
            });
          }
        } else if (
          this.$store.state.storePhotoGiftOrderDesign.cIndexMode ==
          "addNewImageBackground"
        ) {
          if (
            img.image.attr.width ==
              this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                this.activeTab
              ].selected.width &&
            img.image.attr.height ==
              this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                this.activeTab
              ].selected.height
          ) {
            this.setNewDBBackground(img.image.path);
          } else {
            this.$store.state.storePhotoGiftOrderDesign.currentImagePreview = {
              image: img.image.path,
              index: this.activeTab,
              aspectRatio:
                this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                  this.activeTab
                ].selected.cRatio,
              width:
                this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                  this.activeTab
                ].selected.width,
              height:
                this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                  this.activeTab
                ].selected.height,
              oWidth: img.image.attr.width,
              oHeight: img.image.attr.height,
              oAspectRatio: img.image.attr.aspectRatio,
            };
            this.showCropper = true;
          }
        } else if (
          this.$store.state.storePhotoGiftOrderDesign.cIndexMode ==
            "addNewSimpleSquareImage" ||
          this.$store.state.storePhotoGiftOrderDesign.cIndexMode ==
            "addNewSimpleCircleImage"
        ) {
          this.$store.state.storePhotoGiftOrderDesign.currentImagePreview = {
            image: img.image.path,
            index: this.activeTab,
            cIndexMode: "addNewSimpleSquareImage",
            aspectRatio:
              this.$store.state.storePhotoGiftOrderDesign.cIndexMode ==
              "addNewSimpleSquareImage"
                ? NaN
                : 1,
            width: img.image.attr.width,
            height: img.image.attr.height,
            stroke: this.defaultSimpleImageSettings.stroke,
            strokeWidth: this.defaultSimpleImageSettings.strokeWidth,
            borderRadius: this.defaultSimpleImageSettings.borderRadius,
          };
          this.showCropper = true;
        }
        //console.log(this.$store.state.storePhotoGiftOrderDesign.currentImagePreview);
      });
      //console.log(cIndex);
    },
    async addNewCustomSticker(e) {
      this.showImageDatabaseLiveSelection = false;

      readNewSimpleFile(e).then((img) => {
        console.log(
          e,
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
        );
        this.dialogWait = true;
        this.dialogWaitMsg = this.$t("userNewPhotoGiftOrderLoadingStickers");

        fabricJs.addStickerFromFile(
          img,
          e,
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0],
          true,
          this.$vuetify.breakpoint,
          true,
          this.itemCanvasMF[this.activeTab]
        );

        this.dialogWait = false;
      });
    },
    setNewDBBackground(image) {
      this.dialogWait = true;
      this.dialogWaitMsg = this.$t(
        "userNewPhotoGiftOrderLoadingBackgroundImage"
      );
      // render new background image
      let vm = this;
      fabric.Image.fromURL(
        image,
        function (img) {
          if (img._element == null) {
            vm.dialogWait = false;
            console.log("ERROR fabric.Image.fromURL in cropFinal() function ");
            vm.$store.commit({
              type: "showSnackbar",
              color: "error",
              message: this.$t("userNewPhotoGiftOrderLoadingImageError"),
            });
          }
          img.scaleToWidth(
            vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
              vm.activeTab
            ].selected.width * vm.itemCanvasMF[vm.activeTab]
          );
          img.scaleToHeight(
            vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
              vm.activeTab
            ].selected.height * vm.itemCanvasMF[vm.activeTab]
          );

          vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.setBackgroundImage(
            img,
            vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.requestRenderAll.bind(
              vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
                .canvas
            ),
            { crossOrigin: "*" }
          );

          vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.showBackgroundImageControls = true; // prikaz gumbov za upravljanje ozadja
          vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.backgroundImageBrightness = 0; // reset svetlosti ozadja
          vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.backgroundImageContrast = 0; // reset blur ozadja
          vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.backgroundImageBlur = 0; // reset blur ozadja
          vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.backgroundImageFilter = 0; // reset filtra ozadja
          vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.transparentBack = false;
          vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.backgroundColor =
            "#00000000";
          vm.dialogWait = false;
        },
        {
          // Needed to position backgroundImage at 0/0
          originX: "left",
          originY: "top",
          crossOrigin: "anonymous",
        }
      );
    },
    servePixabayBackgroundPatternSelection() {
      this.showPixabayBackgroundPatternSelection = true;
    },
    addFromImageDBPixabayPattern(image) {
      this.showPixabayBackgroundPatternSelection = false;
      this.dialogWait = true;
      this.dialogWaitMsg = this.$t(
        "userNewPhotoGiftOrderLoadingBackgroundImage"
      );

      let vm = this;
      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.setBackgroundColor(
        { source: image, repeat: "repeat", crossOrigin: "*" },
        function () {
          vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.backgroundImage = 0;
          vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.transparentBack = false;
          vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.requestRenderAll();
          vm.dialogWait = false;
        }
      );
      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.showBackgroundImageControls = false; // skrijemo gumbe za upravljanje ozadja
    },
    servePixabayBackgroundImageSelection() {
      this.canvasRatio =
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
          this.activeTab
        ].selected.cRatio;
      this.showPixabayBackgroundSelection = true;
    },
    addFromImageDBPixabay(image) {
      this.cViewMode = 1;
      this.$store.state.storePhotoGiftOrderDesign.cIndexMode =
        "addNewImageBackground";
      this.showPixabayBackgroundSelection = false;

      this.$store.state.storePhotoGiftOrderDesign.currentImagePreview = {
        image: image,
        index: this.activeTab,
        aspectRatio:
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
            this.activeTab
          ].selected.cRatio,
        width:
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
            this.activeTab
          ].selected.width,
        height:
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
            this.activeTab
          ].selected.height,
      };

      this.showCropper = true;
    },
    addFreeDrawing() {
      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.isDrawingMode = true;
      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.showFreeDrawingControls = true;

      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.freeDrawingBrush =
        new fabric.PencilBrush(
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas
        );
      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.freeDrawingBrush.color =
        this.freeDrawingSettings.strokeColor;
      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.freeDrawingBrush.width =
        this.freeDrawingSettings.strokeWidth *
        this.itemCanvasMF[this.activeTab];
      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.freeDrawingBrush.shadow =
        new fabric.Shadow({
          blur:
            this.freeDrawingSettings.shadowBlur *
            this.itemCanvasMF[this.activeTab],
          offsetX: 0,
          offsetY: 0,
          affectStroke: true,
          color: this.freeDrawingSettings.shadowColor,
        });
      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.requestRenderAll();
    },
    applyFreeDrawing() {
      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.showFreeDrawingControls = false;
      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.isDrawingMode = false;

      // iz vseh pathov ustvarimo en sam objekt
      let pathArray = [];
      let objects =
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.getObjects(
          "path"
        );
      for (let i in objects) {
        pathArray.push(objects[i]);
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.remove(
          objects[i]
        ); // izbrišemo original pathe
      }

      if (pathArray.length > 0) {
        let pathGroup = new fabric.Group(pathArray, {
          myType: "freeDrawing",
          selectable: true,
          centeredScaling: true,
          borderColor: "rgba(255,0,0,0.5)",
          cornerStrokeColor: "rgba(0,0,0,0)",
          borderScaleFactor:
            (this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
              this.activeTab
            ].selected.width /
              150) *
            this.itemCanvasMF[this.activeTab],
          rotatingPointOffset:
            (this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
              this.activeTab
            ].selected.width /
              20) *
            this.itemCanvasMF[this.activeTab],
          cornerSize: this.$vuetify.breakpoint.smAndUp
            ? (this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                this.activeTab
              ].selected.width /
                25) *
              this.itemCanvasMF[this.activeTab]
            : (this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
                .selected.width /
                12) *
              this.itemCanvasMF[this.activeTab],
          cornerShape: "rect",
          transparentCorners: true,
        });

        pathGroup.setControlsVisibility({
          tl: true,
          tr: true,
          bl: true,
          br: true,
          ml: true,
          mt: false,
          mr: true,
          mb: false,
          mtr: true,
        });

        pathGroup.customiseCornerIcons({
          tl: {
            icon: require("@/assets/resize-icon-tl.svg"),
          },
          tr: {
            icon: require("@/assets/resize-icon-tr.svg"),
          },
          bl: {
            icon: require("@/assets/delete-icon.svg"),
          },
          br: {
            icon: require("@/assets/resize-icon-br.svg"),
          },
          ml: {
            icon: require("@/assets/down-arrow.svg"),
          },
          mr: {
            icon: require("@/assets/up-arrow.svg"),
          },
          mtr: {
            icon: require("@/assets/rotate-icon.svg"),
          },
        });

        pathGroup.on("selected", function () {
          fabric.Canvas.prototype.customiseControls({
            bl: {
              action: "remove",
              cursor: "pointer",
            },
            ml: {
              cursor: "pointer",
              action: function (e, target) {
                target.sendBackwards(true);
              },
            },
            mr: {
              cursor: "pointer",
              action: function (e, target) {
                target.bringForward(true);
              },
            },
          });
        });

        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas
          .add(pathGroup)
          .requestRenderAll();
      }
    },
    cancelFreeDrawing() {
      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.showFreeDrawingControls = false;
      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.isDrawingMode = false;

      // iz vseh pathov ustvarimo en sam objekt
      let objects =
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.getObjects(
          "path"
        );
      for (let i in objects) {
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.remove(
          objects[i]
        ); // izbrišemo original pathe
      }

      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.requestRenderAll();
    },
    serveZoomCanvas() {
      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.showZoomControls = true;
      // PANZOOM
      this.panzoom = Panzoom(document.getElementById("mainCardText"), {
        maxScale: 4,
        minScale: 0.5,
        step: 0.25,
      });
      //console.log("PAN", this.cPan.x, this.cPan.y);
      this.cZoom = 1;
      this.panzoom.zoom(this.cZoom, { animate: true });
      //this.panzoom.pan(this.cPan.x, this.cPan.y); // ne dela oz. ne znam naštimat
    },
    serveNewText() {
      fabricJs.addText(
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0],
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
          this.activeTab
        ].selected,
        {
          textFunction: 0,
          allowDelete: true,
          allowManipulate: true,
          allowEdit: true,
        },
        this.fonts,
        this.textBrushes,
        this.textBrush,
        this.$t("msgEditText"),
        this.$vuetify.breakpoint,
        true,
        false,
        this.itemCanvasMF[this.activeTab],
        ""
      );
    },
    serveStickersSelection() {
      this.dType = c.G_IMAGE_DATABASE_TYPE_STICKERS;
      this.dTitle = this.$t("fabricSelectStickerDialogTitle");
      this.dIcon = "mdi-sticker-emoji";
      this.showImageDatabaseLiveSelection = true;
    },
    serveFrameImageSelection() {
      this.canvasRatio =
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
          this.activeTab
        ].selected.cRatio;
      this.dType = c.G_IMAGE_DATABASE_TYPE_FRAMES;
      this.dTitle = this.$t("fabricBackgroundImageAddFrameTitle");
      this.dIcon = "mdi-image-outline";
      this.showImageDatabaseLiveSelection = true;
    },
    serveFrameSimpleSquareImageSelection() {
      this.$store.state.storePhotoGiftOrderDesign.cIndexMode =
        "addNewSimpleSquareImage";
      document.getElementById("addNewSimpleSquareImageFileInput").click();
    },
    serveFrameSimpleCircleImageSelection() {
      this.$store.state.storePhotoGiftOrderDesign.cIndexMode =
        "addNewSimpleCircleImage";
      document.getElementById("addNewSimpleCircleImageFileInput").click();
    },
    async addStickerFromImageDB(item) {
      console.log(
        "addStickerFromImageDB",
        item,
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.getActiveObject()
      );
      let incCounter = firebase
        .functions()
        .httpsCallable("incImageDatabaseCounter");

      try {
        incCounter({ id: item.id, counter: item.counter + 1 })
          .then((res) => {
            console.log(res);
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
        return;
      }

      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.showStickerControls = false;

      Object.assign(item, {
        textFunction:
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.getActiveObject()
            .textFunction,
        allowDelete:
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.getActiveObject()
            .allowDelete,
        allowManipulate:
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.getActiveObject()
            .allowManipulate,
        allowReplace:
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.getActiveObject()
            .allowReplace,
        angle:
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.getActiveObject()
            .angle,
        left:
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.getActiveObject()
            .left * this.itemCanvasMF[this.activeTab],
        top:
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.getActiveObject()
            .top * this.itemCanvasMF[this.activeTab],
        scaleX:
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.getActiveObject()
            .scaleX * this.itemCanvasMF[this.activeTab],
        scaleY:
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.getActiveObject()
            .scaleY * this.itemCanvasMF[this.activeTab],
      });

      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.remove(
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.getActiveObject()
      );

      this.dialogWait = true;
      this.dialogWaitMsg = this.$t("userNewPhotoGiftOrderLoadingStickers");

      await fabricJs.addSticker(
        item,
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
          this.activeTab
        ].selected,
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0],
        false,
        this.$vuetify.breakpoint,
        true,
        this.itemCanvasMF[this.activeTab]
      );

      this.dialogWait = false;
    },
    async addFromImageDB(item) {
      let incCounter = firebase
        .functions()
        .httpsCallable("incImageDatabaseCounter");

      try {
        incCounter({ id: item.id, counter: item.counter + 1 })
          .then((res) => {
            console.log(res);
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
        return;
      }

      if (this.dType == c.G_IMAGE_DATABASE_TYPE_STICKERS) {
        this.showImageDatabaseLiveSelection = false;
        this.dialogWait = true;
        this.dialogWaitMsg = this.$t("userNewPhotoGiftOrderLoadingStickers");

        await fabricJs.addSticker(
          item,
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
            this.activeTab
          ].selected,
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0],
          true,
          this.$vuetify.breakpoint,
          true,
          this.itemCanvasMF[this.activeTab]
        );

        this.dialogWait = false;
      } else if (this.dType == c.G_IMAGE_DATABASE_TYPE_BACKGROUNDS) {
        this.showImageDatabaseLiveSelection = false;
        this.cViewMode = 1;
        this.$store.state.storePhotoGiftOrderDesign.cIndexMode =
          "addNewImageBackground";

        // če je točna dimezija izbrane slike, potem ne pokažemo cropperja
        if (
          item.width ==
            this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
              this.activeTab
            ].selected.width &&
          item.height ==
            this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
              this.activeTab
            ].selected.height
        ) {
          this.setNewDBBackground(item.image);
        } else {
          this.$store.state.storePhotoGiftOrderDesign.currentImagePreview = {
            image: item.image,
            index: this.activeTab,
            aspectRatio:
              this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                this.activeTab
              ].selected.cRatio,
            width:
              this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                this.activeTab
              ].selected.width,
            height:
              this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                this.activeTab
              ].selected.height,
          };

          // če se ozadje ne ujema po orientaciji, ga obrnemo, če ima rotate: true v bazi
          if (
            ((item.aRatio > 1 &&
              this.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                .aspectRatio <= 1) ||
              (item.aRatio <= 1 &&
                this.$store.state.storePhotoGiftOrderDesign.currentImagePreview
                  .aspectRatio > 1)) &&
            item.rotate &&
            this.$store.state.storePhotoGiftOrderDesign.currentImagePreview
              .aspectRatio != 1
          ) {
            let vm = this;
            readAndRotateUrlFile(item, false).then((img) => {
              vm.$store.state.storePhotoGiftOrderDesign.currentImagePreview.image =
                img.path;
              vm.showCropper = true;
            });
          } else {
            this.$store.state.storePhotoGiftOrderDesign.currentImagePreview.image =
              item.image;
            this.showCropper = true;
          }
        }
      } else if (this.dType == c.G_IMAGE_DATABASE_TYPE_PATTERNS) {
        this.showImageDatabaseLiveSelection = false;

        let vm = this;
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.setBackgroundColor(
          { source: item.image, repeat: "repeat", crossOrigin: "*" },
          function () {
            vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.backgroundImage = 0;
            vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.transparentBack = false;
            vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.requestRenderAll();
          }
        );
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.showBackgroundImageControls = false; // skrijemo gumbe za upravljanje ozadja
      } else if (this.dType == c.G_IMAGE_DATABASE_TYPE_FRAMES) {
        this.showImageDatabaseLiveSelection = false;
        this.cViewMode = 1;

        this.$store.state.storePhotoGiftOrderDesign.currentImagePreview = {
          index: this.activeTab,
          aspectRatio: 0,
          width: 0,
          height: 0,
          scaleX: 1,
          scaleY: 1,
          item: item,
          coordAspectRatio: item.coordinates.width / item.coordinates.height,
          coordinates: item.coordinates,
        };
        //console.log("item", this.$store.state.storePhotoGiftOrderDesign.currentImagePreview);
        this.handlerAddNewImage("addNewExtraImage");
      }
    },
    handlerAddCollage(imageMode) {
      this.$store.state.storePhotoGiftOrderDesign.cIndexMode = imageMode;
      document.getElementById("addCollageFileInput").click();
    },
    async generateCollage(e) {
      // reset file input fielda, da lahko izeremo 2x enakosliko
      this.uploadReady = false;
      this.$nextTick(() => {
        this.uploadReady = true;
      });

      this.dialogWait = true;
      let photos = [];
      const promises = [];
      let landscape = 0,
        portrait = 0,
        multiply = 1;

      e.target.files.forEach((x) => {
        promises.push(
          readImageDimensionsWithSrc(x).then((y) => {
            if (y.image.attr.orientation == "landscape") {
              landscape++;
            } else portrait++;

            /*console.log(
              y.image.attr.name,
              y.image.attr.width,
              y.image.attr.height,
              y.image.attr.aspectRatio
            );*/
            photos.push({
              data: y.image.attr.name,
              src: y.image.path,
              width: y.image.attr.width,
              height: y.image.attr.height,
              ratio: y.image.attr.aspectRatio,
            });
          })
        );
      });

      await Promise.all(promises)
        .then(() => {
          // ugibanje ali multiply dejansko vpliva na izračun? mislim, da ne kaj preveč
          if (photos.length == 1) {
            multiply = 1;
          } else if (photos.length == 2) {
            if (
              Number(
                this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
                  .canvas.width
              ) /
                Number(
                  this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
                    .canvas.height
                ) >
              1
            ) {
              multiply = 1;
            } else multiply = 2;
          } else if (photos.length == 3) {
            multiply = 3;
          } else multiply = 3;

          console.log("landscape", landscape);
          console.log("portrait", portrait);
          console.log("multiply", multiply);

          let result = layout(photos, {
            align: "center", // optional
            containerWidth:
              this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
                .canvas.width,
            idealElementHeight:
              this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
                .canvas.height / multiply,
            spacing: 0,
          });

          let group1 = new fabric.Group([], {
            myType: "collageGroup",
            angle: 0,
            originX: "center",
            originY: "center",
            selectable: true,
            centeredScaling: true,
            borderColor: "rgba(255,0,0,0.5)",
            cornerStrokeColor: "rgba(0,0,0,0)",
            borderScaleFactor:
              (this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                this.activeTab
              ].selected.width /
                150) *
              this.itemCanvasMF[this.activeTab],
            rotatingPointOffset:
              (this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                this.activeTab
              ].selected.width /
                20) *
              this.itemCanvasMF[this.activeTab],
            cornerSize: this.$vuetify.breakpoint.smAndUp
              ? (this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                  this.activeTab
                ].selected.width /
                  25) *
                this.itemCanvasMF[this.activeTab]
              : (this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                  this.activeTab
                ].selected.width /
                  12) *
                this.itemCanvasMF[this.activeTab],
            cornerShape: "rect",
            transparentCorners: true,
          });

          // Render in canvas in propper layer order position
          let c = 0;
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.forEachObject(
            (x) => {
              if (
                x.myType != "simpleImage" &&
                x.myType != "sticker" &&
                x.myType != "text" &&
                x.myType != "freeDrawing"
              )
                c++;
            }
          );

          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas
            .insertAt(group1, c)
            .requestRenderAll();

          group1.setControlsVisibility({
            tl: true,
            tr: true,
            bl: true,
            br: true,
            ml: true,
            mt: false,
            mr: true,
            mb: false,
            mtr: true,
          });

          group1.customiseCornerIcons({
            tl: {
              icon: require("@/assets/resize-icon-tl.svg"),
            },
            tr: {
              icon: require("@/assets/resize-icon-tr.svg"),
            },
            bl: {
              icon: require("@/assets/delete-icon.svg"),
            },
            br: {
              icon: require("@/assets/resize-icon-br.svg"),
            },
            ml: {
              icon: require("@/assets/down-arrow.svg"),
            },
            mr: {
              icon: require("@/assets/up-arrow.svg"),
            },
            mtr: {
              icon: require("@/assets/rotate-icon.svg"),
            },
          });

          group1.on("selected", function () {
            fabric.Canvas.prototype.customiseControls({
              bl: {
                action: "remove",
                cursor: "pointer",
              },
              br: {
                cursor: "resize",
                action: "scale",
              },
              ml: {
                cursor: "pointer",
                action: function (e, target) {
                  target.sendBackwards(true);
                },
              },
              mr: {
                cursor: "pointer",
                action: function (e, target) {
                  target.bringForward(true);
                },
              },
            });
          });

          for (let i = 0, n = photos.length; i < n; i++) {
            let vm = this;
            fabric.Image.fromURL(photos[i].src, (myImg) => {
              let img1 = myImg.set({
                left: result.positions[i].x + result.positions[i].width / 2,
                top: result.positions[i].y + result.positions[i].height / 2,
                originX: "center",
                originY: "center",
                myType: "collageImage",
                angle: 0,
                /*stroke: "white",
                strokeWidth:
                  vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[
                    vm.activeTab
                  ].selected.width /
                  40 *
                  vm.itemCanvasMF[vm.activeTab],*/
              });
              img1.scaleToWidth(result.positions[i].width);
              img1.scaleToHeight(result.positions[i].height);

              /*console.log(
                result.positions[i].x,
                result.positions[i].y,
                result.positions[i].width,
                result.positions[i].height
              );*/

              group1.addWithUpdate(img1);

              // Na koncu premaknemo ali zmanjšamo kolaž => fit-in
              if (i == photos.length - 1) {
                let gHeight =
                  result.positions[result.positions.length - 1].height;
                let cHeight = Number(
                  vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
                    .canvas.height
                );

                //console.log(result);
                console.log(
                  "group1.height",
                  group1.height,
                  "gHeight",
                  gHeight,
                  "cHeight",
                  cHeight
                );

                if (group1.height > cHeight) {
                  // daljši group, zmanjšamo da bo fit-in po višini
                  group1.set({
                    top: cHeight / 2,
                  });
                  group1.scaleToHeight(cHeight);
                  console.log("shrink");
                } else if (group1.height < cHeight) {
                  // manjši group, premaknemo na sredino
                  /*group1.set({
                    top: group1.top - (group1.height - cHeight) / 2
                  });*/
                  /*group1.dirty = true;
                  vm.canvasTemplates[vm.cIndex].canvas.setActiveObject(group1);
                  vm.canvasTemplates[vm.cIndex].canvas.requestRenderAll();*/
                  console.log("move", group1.height);
                }
              }
              vm.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.requestRenderAll();
            });
          }

          console.log("ADDED COLLAGE");
          this.dialogWait = false;
        })
        .catch((err) => {
          console.log(err);
          this.dialogWait = false;
        });
    },
    checkOverrideSize() {
      if (this.$store.state.storePhotoGiftOrderDesign.overrideSize) {
        let overrideAR =
          Number(
            this.$store.state.storePhotoGiftOrderDesign.overrideSizeWidth
          ) /
          Number(
            this.$store.state.storePhotoGiftOrderDesign.overrideSizeHeight
          );
        let selectedAR =
          Number(
            this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
              .selected.width
          ) /
          Number(
            this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
              .selected.height
          );

        if (
          (selectedAR >= 1 && overrideAR >= 1) ||
          (selectedAR < 1 && overrideAR < 1)
        ) {
          // izračun faktorja povečave
          this.overrideWidthFactor =
            (this.$store.state.storePhotoGiftOrderDesign.overrideSizeWidth *
              100) /
            this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
              .selected.width /
            100;
          this.overrideHeightFactor =
            (this.$store.state.storePhotoGiftOrderDesign.overrideSizeHeight *
              100) /
            this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
              .selected.height /
            100;

          // če je orientacija templatea enaka override orientaciji
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].selected.cRatio =
            overrideAR;
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].selected.width =
            this.$store.state.storePhotoGiftOrderDesign.overrideSizeWidth;
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].selected.height =
            this.$store.state.storePhotoGiftOrderDesign.overrideSizeHeight;
        } else {
          // izračun faktorja povečave
          this.overrideWidthFactor =
            (this.$store.state.storePhotoGiftOrderDesign.overrideSizeHeight *
              100) /
            this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
              .selected.width /
            100;
          this.overrideHeightFactor =
            (this.$store.state.storePhotoGiftOrderDesign.overrideSizeWidth *
              100) /
            this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
              .selected.height /
            100;

          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].selected.cRatio =
            this.$store.state.storePhotoGiftOrderDesign.overrideSizeHeight /
            this.$store.state.storePhotoGiftOrderDesign.overrideSizeWidth;
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].selected.width =
            this.$store.state.storePhotoGiftOrderDesign.overrideSizeHeight;
          this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].selected.height =
            this.$store.state.storePhotoGiftOrderDesign.overrideSizeWidth;
        }
      }
      setTimeout(() => {
        console.log("Check override size...");
      }, 0);
    },
  },
  created() {
    this.G_IMAGE_DATABASE_TYPE_STICKERS = c.G_IMAGE_DATABASE_TYPE_STICKERS;
  },
  mounted() {
    // ali imamo kaj nujnih slik v predlogi?
    this.itemsAvailable =
      ("rulesSimple" in
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
          .selected &&
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].selected
          .rulesSimple.length > 0) ||
      ("rulesFrames" in
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
          .selected &&
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].selected
          .rulesFrames.length > 0) ||
      ("rules" in
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0]
          .selected &&
        this.$store.state.storePhotoGiftOrderDesign.canvasTemplates[0].selected
          .rules.length > 0)
        ? true
        : false;

    this.winW = document.getElementById("mainCardText").offsetWidth;
    this.winH =
      document.getElementById("mainCardText").offsetHeight -
      document.getElementById("mainCardToolbar").offsetHeight -
      document.getElementById("mainToolbar").offsetHeight -
      document.getElementById("mainCardActions").offsetHeight -
      document.getElementById("mainCardFiles").offsetHeight;

    document.getElementById("mainCardText").style.height = this.winH + "px";

    // pogledamo ali gre za kolaž in spremenimo dimenzije slike (override size)
    this.checkOverrideSize();

    if (this.$store.state.storePhotoGiftOrderDesign.allowCustomSize) {
      this.applyCustomSizeStart = true;
      this.customSizeDialog = true;
    } else {
      this.prepareSingleCanvas(0, true);
    }

    if (
      "ontouchstart" in document.documentElement &&
      this.$store.state.storePhotoGiftOrderDesign.canvasTemplates.length > 1
    )
      this.$store.commit({
        type: "showSnackbar",
        color: "success",
        message: this.$t("userNewPhotoGiftOrderDesignSwipeInfo"),
      });
  },
};
</script>

<style scoped>
@import "../../mixins/fonts/loadFonts.css";
.hover-item {
  cursor: pointer;
}
.headerClass {
  white-space: nowrap;
  word-break: normal;
  overflow: hidden;
}
.canvasShadow {
  -webkit-box-shadow: 0px 0px 2px 2px #bbbbbb; /* Safari 3-4, iOS 4.0.2 - 4.2, Android 2.3+ */
  -moz-box-shadow: 0px 0px 2px 2px #bbbbbb; /* Firefox 3.5 - 3.6 */
  box-shadow: 0px 0px 2px 2px #bbbbbb; /* Opera 10.5, IE 9, Firefox 4+, Chrome 6+, iOS 5 */
}
.img-container {
  /* Never limit the container height here */
  max-width: 100%;
}
.img-container img {
  /* This is important */
  width: 100%;
}
/* edina opcija da spremenim prepend-icon barvo? */
/*.mdi-image-plus::before {
  color: #25832c;
}*/
</style>